// AUTO-GENERATED by /app/scripts/generate_bundled_translations.py.
// DO NOT EDIT BY HAND. Re-run the script when you add new <Tr> strings.
// Maps English source → { lang_code: translated_string }.
// Hydrated at app boot via hydrateBundledTranslations() so EVERY
// pre-translated string flips to the target language without
// hitting the network. This is what makes the language picker feel
// instant on cold cache.

// Generated: 149 source strings × 18 languages

export default {
  "\"In the beginning was the Word\"": {
    "es": "\" En el principio era el Verbo ... \"",
    "fr": "\" Au commencement était le Verbe... \"",
    "pt": "\"No princípio era o Verbo,",
    "de": "Im Anfang war das Wort,",
    "it": "All inizio era il Verbo,,",
    "ru": "В начале было Слово",
    "hi": "\"आदि में वचन था\"",
    "ar": "\" فِي الْبَدْءِ كَانَ الْكَلِمَةُ\".",
    "zh-CN": "“太初有道”。",
    "sw": "Katika mwanzo kulikuwa na Neno",
    "ko": "태초에 말씀이 있었다",
    "vi": "Trong lúc ban đầu là Lời",
    "tl": "Sa simula ay nandoon na ang Salita",
    "ht": "Nan kòmansman an, te gen Pawòl la",
    "ja": "初めに、言葉がありました",
    "nl": "In het begin was het Woord",
    "pl": "Na początku było Słowo",
    "tr": "Başlangıçta Söz vardı"
  },
  "200+ gospel tracks for car rides": {
    "es": "Más de200 pistas gospel para viajes en coche",
    "fr": "Plus de200 pistes gospel pour les trajets en voiture",
    "pt": "Mais de200 trilhas gospel para viagens de carro",
    "de": "Über 200 Gospel-Tracks für Autofahrten",
    "it": "Oltre 200 tracce gospel per i viaggi in auto",
    "ru": "Более200 госпел-треков для поездок на автомобиле",
    "hi": "कार राइड के लिए 200 से भी ज़्यादा गॉस्पेल ट्रैक",
    "ar": "أكثر من 200 مسار إنجيلي لركوب السيارات",
    "zh-CN": "200多首福音曲目，适合汽车行程",
    "sw": "Nyimbo zaidi ya 200 za Injili kwa ajili ya safari za gari",
    "ko": "자동차 타기에 좋은 200개 이상의 복음 트랙",
    "vi": "Hơn 200 bài hát phúc âm cho việc đi xe hơi",
    "tl": "200+ mga awit ng Gospel para sa pagmamaneho sa sasakyan",
    "ht": "200+ chanson Evanjil pou vwayaj nan machin",
    "ja": "車での移動のための200以上のゴスペルトラック",
    "nl": "200+ gospelnummers voor autorits",
    "pl": "200+ utworów gospelowych na podróże samochodem",
    "tr": "200+ müjde yolculuğu için şarkı"
  },
  "23 clean-comedy legends in one place — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq and more.": {
    "es": "23 leyendas de comedia limpia en un solo lugar: Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq y más.",
    "fr": "23 légendes de la comédie propre en un seul endroit — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq et plus encore.",
    "pt": "23 lendas da comédia limpa num só lugar — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq e muito mais.",
    "de": "23 Clean-Comedy-Legenden an einem Ort — Sindbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq und mehr.",
    "it": "23 leggende della commedia pulita in un unico posto: Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq e altro ancora.",
    "ru": "23 легенды чистой комедии в одном месте — Синдбад, Майкл-младший, Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Али Сиддик и другие.",
    "hi": "एक ही स्थान पर 23 स्वच्छ - कॉमेडी किंवदंतियों — सिनबाद, माइकल जूनियर।, क्रिस टकर, कंट्री वेन, केवऑनस्टेज, रॉय वुड जूनियर, अली सिद्दीक और बहुत कुछ।",
    "ar": "23 أسطورة كوميدية نظيفة في مكان واحد — سندباد، مايكل جونيور.، كريس تاكر، كونتري واين، كيفون ستيج، روي وود جونيور. وعلي صديق وأكثر.",
    "zh-CN": "23个干净的喜剧传奇集中在一个地方—小迈克尔·辛巴达、Chris Tucker、Kountry Wayne、KevOnStage、Roy Wood Jr.、Ali Siddiq等等。",
    "sw": "Hadithi 23 za utendaji wa taharusi safi katika mahali pamoja — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq na mengine.",
    "ko": "23명의 클린 코미디 전설들이 한곳에 모였다 — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq 등.",
    "vi": "23 huyền thoại hài kịch sạch ở một nơi — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq và nhiều hơn nữa.",
    "tl": "23 clean-comedy legends sa isang lugar — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq at marami pa.",
    "ht": "23 lejand nan komikal ki pwòp nan yon sèl plas — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq ak plis ankò.",
    "ja": "23人のクリーンコメディの伝説が一堂に集結—シンバッド、マイケル・ジュニア、クリス・タッカー、カントリー・ウェイン、ケヴォンステージ、ロイ・ウッド・ジュニア、アリ・シディク、その他多数。",
    "nl": "23 clean-comedy legenden op één plek — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq en meer.",
    "pl": "23 legendy czystego humoru w jednym miejscu — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq i inni.",
    "tr": "Bir yerde 23 temiz komedi efsanesi — Sinbad, Michael Jr., Chris Tucker, Kountry Wayne, KevOnStage, Roy Wood Jr., Ali Siddiq ve daha fazlası."
  },
  "A family-friendly corner with Bible cartoons, animated stories, and faith-based movies kids love. Look for the \"Play in app\" badge — those titles stream right here without leaving the app.": {
    "es": "Un rincón familiar con dibujos animados de la Biblia, historias animadas y películas basadas en la fe que a los niños les encantan. Busca la insignia \"Reproducir en la aplicación\": esos títulos se transmiten aquí sin salir de la aplicación.",
    "fr": "Un coin familial avec des dessins animés bibliques, des histoires animées et des films religieux que les enfants adorent. Recherchez le badge « Jouer dans l'application » — ces titres sont diffusés ici sans quitter l'application.",
    "pt": "Um recanto familiar com desenhos animados da Bíblia, histórias animadas e filmes baseados na fé que as crianças adoram. Procure o emblema \"Jogar na aplicação\" — esses títulos são transmitidos aqui mesmo sem sair da aplicação.",
    "de": "Eine familienfreundliche Ecke mit Bibel-Cartoons, animierten Geschichten und glaubensbasierten Filmen, die Kinder lieben. Suchen Sie nach dem \"Play in app\" -Badge — diese Titel streamen direkt hier, ohne die App zu verlassen.",
    "it": "Un angolo adatto alle famiglie con cartoni animati biblici, storie animate e film basati sulla fede che i bambini adorano. Cerca il badge \"Gioca nell'app\": quei titoli vengono trasmessi qui senza uscire dall'app.",
    "ru": "Семейный уголок с библейскими мультфильмами, анимационными историями и религиозными фильмами, которые нравятся детям. Ищите значок «Играть в приложении» — эти названия транслируются прямо здесь, не выходя из приложения.",
    "hi": "बाइबल कार्टून, एनिमेटेड कहानियों और विश्वास - आधारित फिल्मों के साथ एक परिवार के अनुकूल कोने बच्चों को पसंद है। \"ऐप में खेलें\" बैज देखें — ऐप से बाहर निकले बिना ही उन टाइटल को यहीं स्ट्रीम करें।",
    "ar": "ركن مناسب للعائلة مع رسوم كاريكاتورية من الكتاب المقدس وقصص متحركة وأفلام دينية يحبها الأطفال. ابحث عن شارة \"التشغيل في التطبيق\" — يتم بث هذه العناوين هنا دون مغادرة التطبيق.",
    "zh-CN": "适合家庭入住的角落，有圣经漫画、动画故事和孩子们喜欢的基于信仰的电影。寻找“在应用程序中播放”徽章—这些标题直接在这里播放，而无需离开应用程序。",
    "sw": "Kona ya familia yenye katuni za Biblia, hadithi zenye uhuishaji, na filamu zenye msingi wa imani ambayo watoto wanapenda. Tafuta nishani ya \"Cheza katika programu\" — kichwa cha karatasi hicho kinachacha moja kwa moja hapa bila kuondoka katika programu.",
    "ko": "가족 모두가 즐길 수 있는 코너로, 성경 만화, 애니메이션 이야기, 아이들이 사랑하는 신앙 기반 영화들을 제공합니다. \"앱에서 재생\" 배지를 찾아보세요 — 해당 타이틀들은 앱을 떠나지 않고도 여기서 바로 스트리밍됩니다.",
    "vi": "Một góc thân thiện với gia đình có các bộ phim hoạt hình Kinh Thánh, những câu chuyện hoạt hình và các bộ phim dựa trên đức tin mà trẻ em yêu thích. Tìm kiếm huy hiệu \"Phát trong ứng dụng\" — những tiêu đề đó phát trực tuyến ngay tại đây mà không cần rời khỏi ứng dụng.",
    "tl": "Isang pamilya-friendly na sulok na may Bible cartoons, animated stories, at faith-based na mga pelikula na mahal ng mga bata. Hanapin ang \"Play in app\" badge — ang mga pamagalang na iyon ay nag-stream dito nang direkta nang hindi iiwan ang app.",
    "ht": "Yon kwen ki anpil fanmi renmen avèk karikati Bibliy, istwa anime, ak fim ki baze sou fe ke timoun yo renmen. Gade badge \"Jwe nan app\" - sa yo se tit ki diffize dirèk la san ou pa bezwen kite app la.",
    "ja": "家族向けのコーナーで、聖書漫画、アニメーション化された物語、子どもたちが大好きな信仰に基づいた映画があります。「アプリで再生」バッジを探してください。それらのタイトルはアプリを離れることなくここでストリーミングできます。",
    "nl": "Een gezinsvriendelijke hoek met Bijbelcartoons, geanimeerde verhalen en films gebaseerd op het geloof waar kinderen van houden. Zoek naar het \"Afspelen in app\"-badge — die titels streamen hier rechtstreeks zonder de app te verlaten.",
    "pl": "Rodzinny kątek z biblijnymi kreskówkami, animowanymi historiami i filmami pełnymi wiary, które dzieci kochają. Szukaj oznaczenia „Odtwórz w aplikacji\" — te tytuły możesz przesyłać strumieniowo tutaj bez opuszczania aplikacji.",
    "tr": "Ailelerin keyif alacağı bir köşe; İncil çizgi romanları, animasyonlu hikayeler ve çocukların sevdiği imana dayalı filmler burada. \"Uygulamada Oynat\" rozeti arayın — bu başlıklar doğrudan burada oynatılır, uygulamadan çıkmanıza gerek olmaz."
  },
  "Accept": {
    "es": "Aceptar",
    "fr": "Accepter",
    "pt": "Aceitar",
    "de": "Annehmen",
    "it": "Accetta",
    "ru": "Принять",
    "hi": "स्वीकार करें",
    "ar": "القبول",
    "zh-CN": "接受",
    "sw": "Kubali",
    "ko": "수용하다",
    "vi": "Chấp nhận",
    "tl": "Tumanggap",
    "ht": "Aksepte",
    "nl": "Accepteer",
    "pl": "Zaakceptuj",
    "tr": "Kabul et"
  },
  "Across Scripture, Apocrypha, Book of Jasher, Precepts, Dictionary, Concordance, and Media — all at once.": {
    "es": "A través de las Escrituras, los libros apócrifos, el Libro de Jaser, los Preceptos, el Diccionario, la Concordancia y los Medios, todo a la vez.",
    "fr": "À travers les Écritures, les Apocryphes, le Livre de Jasher, les Préceptes, le Dictionnaire, la Concordance et les Médias — tout à la fois.",
    "pt": "Nas Escrituras, Apócrifos, Livro de Jasar, Preceitos, Dicionário, Concordância e Mídia — tudo de uma vez.",
    "de": "Überall in der Schrift, in den Apokryphen, im Buch Jasher, in den Geboten, im Wörterbuch, in der Konkordanz und in den Medien — alles auf einmal.",
    "it": "Attraverso la Scrittura, gli Apocrifi, il Libro di Jasher, i Precetti, il Dizionario, la Concordanza e i Media — tutto in una volta.",
    "ru": "Через Писание, Апокрифы, Книгу Яшера, Заповеди, Словарь, Согласие и СМИ — все сразу.",
    "hi": "पवित्रशास्त्र के पार, अपोक्रिफा, याशर की पुस्तक, उपदेश, शब्दकोश, सामंजस्य, और मीडिया — सभी एक साथ।",
    "ar": "عبر الكتاب المقدس، أبوكريفا، كتاب جاشر، التعاليم، القاموس، التوافق، ووسائل الإعلام — كل ذلك في وقت واحد.",
    "zh-CN": "跨越圣经、次经、雅煞书、箴言、词典、经文汇编和媒体——同时全部涵盖。",
    "sw": "Kwa njia ya Maandiko Matakatifu, Maandiko Yasiyo Rasmi, Kitabu cha Jasher, Masharti, Kamusi, Hadithi ya Maneno, na Midya — yote kwa wakati mmoja.",
    "ko": "성경, 외경, 야셀의 책, 교훈, 사전, 성경 용어 색인, 그리고 미디어 — 모두 동시에.",
    "vi": "Xuyên suốt Kinh Thánh, Sách Apocrypha, Sách Jasher, Giáo Lệnh, Từ Điển, Sách Chỉ Dẫn, và Phương Tiện Truyền Thông — tất cả cùng một lúc.",
    "tl": "Sa buong Scriptura, Apocrypha, Libro ng Jasher, Mga Prinsipyo, Diksyunaryo, Concordancia, at Media — lahat nang sabay-sabay.",
    "ht": "Atravè Ekri, Apokrèf, Liv Jashe, Presetp, Diksyonè, Konkordans, ak Media — tout ansanm an menm tan.",
    "ja": "聖書、外典、ヤシャルの書、教義、辞書、聖書語句索引、メディア——すべてが同時に。",
    "nl": "Over heel de Schrift, Apocriefen, Boek van Jasher, Voorschriften, Woordenboek, Concordantie en Media — allemaal tegelijk.",
    "pl": "We wszystkich pismach, apokryfach, Księdze Jashera, Przykazaniach, Słowniku, Konkordancji i Mediach — wszystko naraz.",
    "tr": "Kutsal Metinler, Apokrif Yazılar, Yaşer Kitabı, Öğretiler, Sözlük, Kur'an İndeksi ve Medya'ya — hepsi aynı anda."
  },
  "Add": {
    "es": "Añadir",
    "fr": "Ajouter",
    "de": "Hinzufügen",
    "it": "Aggiungi",
    "ru": "Добавить",
    "hi": "जोड़ें",
    "ar": "إضافة",
    "sw": "Ongeza",
    "ko": "더하다",
    "vi": "Thêm",
    "ht": "Ajoute",
    "nl": "Optellen",
    "tr": "Ekle"
  },
  "Add videos from any creator's channel — they'll line up here.": {
    "es": "Añade vídeos del canal de cualquier creador: aparecerán aquí.",
    "fr": "Ajoutez des vidéos à partir de la chaîne de n'importe quel créateur : elles s'aligneront ici.",
    "pt": "Adicione vídeos do canal de qualquer criador — eles estarão alinhados aqui.",
    "de": "Füge Videos aus dem Kanal eines jeden Kreativen hinzu — sie werden hier aufgereiht.",
    "it": "Aggiungi video dal canale di qualsiasi creator: si allineeranno qui.",
    "ru": "Добавьте видео с любого канала креатора — они появятся здесь.",
    "hi": "किसी भी क्रिएटर के चैनल से वीडियो जोड़ें — वे यहाँ लाइन में लगेंगे.",
    "ar": "أضف مقاطع فيديو من أي قناة منشئ محتوى — ستصطف هنا.",
    "zh-CN": "添加来自任何创作者频道的视频，它们将在此处排列。",
    "sw": "Ongeza video kutoka kwa chaneli ya mwumbaji yeyote — zitakuwa zimetenganishwa hapa.",
    "ko": "어떤 크리에이터의 채널에서든 동영상을 추가하세요. 동영상들이 여기에 정렬됩니다.",
    "vi": "Thêm video từ kênh của bất kỳ người sáng tạo nào — chúng sẽ xếp hàng tại đây.",
    "tl": "Magdagdag ng mga video mula sa anumang channel ng creator — limiligay dito ang mga ito.",
    "ht": "Ajoute videyo soti nan nenpòt kanal kreyatè — yo va aliye isit la.",
    "ja": "どのクリエイターのチャンネルからでも動画を追加できます。ここに並びます。",
    "nl": "Voeg video's toe van een willekeurig kanaal van creators — ze zullen hier op een rij staan.",
    "pl": "Dodaj filmy z kanału dowolnego twórcy — będą się wyświetlać tutaj.",
    "tr": "Herhangi bir yaratıcının kanalından videoları ekleyin — burada sıraya dizilecekler."
  },
  "All apocryphal books": {
    "es": "Todos los libros apócrifos",
    "fr": "Tous les livres apocryphes",
    "pt": "Todos os livros apócrifos",
    "de": "Alle apokryphen Bücher",
    "it": "Tutti i libri apocrifi",
    "ru": "Все апокрифические книги",
    "hi": "सभी apocryphal किताबें",
    "ar": "جميع الكتب الملفقة",
    "zh-CN": "所有未经证实的书籍",
    "sw": "Vitabu vyote vya apokryfa",
    "ko": "모든 외경 도서",
    "vi": "Tất cả các sách giả tạo",
    "tl": "Lahat ng apokripong libro",
    "ht": "Tout liv apokrèf yo",
    "ja": "すべての外典の書",
    "nl": "Alle apocriefen boeken",
    "pl": "Wszystkie książki apokryficzne",
    "tr": "Tüm apokrif kitaplar"
  },
  "All faith-based family films & VeggieTales": {
    "es": "Todas las películas familiares basadas en la fe y VeggieTales",
    "fr": "Tous les films familiaux confessionnels et VeggieTales",
    "pt": "Todos os filmes familiares baseados na fé e VeggieTales",
    "de": "Alle glaubensbasierten Familienfilme & VeggieTales",
    "it": "Tutti i film per famiglie basati sulla fede e VeggieTales",
    "ru": "Все религиозные семейные фильмы и вегетарианские сказки",
    "hi": "सभी विश्वास - आधारित पारिवारिक फिल्में और VeggieTales",
    "ar": "جميع الأفلام العائلية القائمة على العقيدة وحكايات الخضروات",
    "zh-CN": "所有基于信仰的家庭电影和VeggieTales",
    "sw": "Filamu zote za familia zenye msingi wa imani na VeggieTales",
    "ko": "모든 믿음을 바탕으로 한 가족 영화 & VeggieTales",
    "vi": "Tất cả các bộ phim gia đình dựa trên đức tin và VeggieTales",
    "tl": "Lahat ng pang-iman na pelikula para sa pamilya at VeggieTales",
    "ht": "Tout fim fanmi ki baze sou konfyans & VeggieTales",
    "ja": "すべての信仰に基づいた家族向け映画とベジテイルズ",
    "nl": "Alle op geloof gebaseerde familiefilms en VeggieTales",
    "pl": "Wszystkie filmy familijne oparte na wierze i VeggieTales",
    "tr": "Tüm imana dayalı aile filmleri ve VeggieTales"
  },
  "An open scripture experience": {
    "es": "Una experiencia abierta de las Escrituras",
    "fr": "Une expérience scripturaire ouverte",
    "pt": "Uma experiência de escritura aberta",
    "de": "Eine offene Schrift-Entdeckung",
    "it": "Un'esperienza scritturale aperta",
    "ru": "Открытое Священное Писание",
    "hi": "एक खुला शास्त्र अनुभव",
    "ar": "تجربة كتابية مفتوحة",
    "zh-CN": "开放的经文体验",
    "sw": "Uzoefu wa Unukuzi wa Maandiko Yatakatifu ambayo ni Wazi",
    "ko": "열린 성경 경험",
    "vi": "Một trải nghiệm Kinh Thánh mở cửa",
    "tl": "Isang bukas na karanasan sa Alaala",
    "ht": "Yon eksperyans ekip ki louvri",
    "ja": "開かれた聖書の経験",
    "nl": "Een open schriftuur-ervaring",
    "pl": "Otwarte doświadczenie Pisma Świętego",
    "tr": "Açık bir Kutsal Yazı deneyimi"
  },
  "Animated Bible stories": {
    "es": "Historias bíblicas animadas",
    "fr": "Histoires bibliques animées",
    "pt": "Histórias bíblicas animadas",
    "de": "Animierte Bibelgeschichten",
    "it": "Racconti biblici animati",
    "ru": "Анимированные библейские истории",
    "hi": "एनिमेटेड बाइबल कहानियाँ",
    "ar": "قصص الكتاب المقدس المتحركة",
    "zh-CN": "动画圣经故事",
    "sw": "Hadithi za Biblia zinazobadilika",
    "ko": "움직이는 성경 이야기",
    "vi": "Những câu chuyện Kinh Thánh hoạt hình",
    "tl": "Mga Nilikhaing Kuwento mula sa Bibliya",
    "ht": "Istwa Bib ki animé",
    "ja": "アニメーション化された聖書の物語",
    "nl": "Geanimeerde bijbelverhalen",
    "pl": "Ożywione biblijne opowieści",
    "tr": "Canlandırılmış İncil Hikayeleri"
  },
  "Apocrypha & Jasher": {
    "es": "Apócrifos y Jasher",
    "fr": "Apocryphes et Jasher",
    "de": "Apokryphen & Jasher",
    "ru": "Апокрифы и яшер",
    "hi": "अपोक्रिफा एंड जैशर",
    "ar": "أبوكريفا وجاشر",
    "zh-CN": "伪经和雅煞书",
    "sw": "Apokryfa & Jasher",
    "ko": "외경 & 야셀",
    "vi": "Sách Ngoài Kinh Thánh & Jasher",
    "tl": "Apocrypha at Jasher",
    "ht": "Apokrèf ak Jasèr",
    "ja": "外典とヤシャル書",
    "nl": "Apocriefen & Jasher",
    "pl": "Apokryfa i Jasher",
    "tr": "Apokrifa & Yaşer"
  },
  "Appearance": {
    "es": "Apariencia",
    "fr": "Aspect",
    "pt": "Aparência,",
    "de": "Aussehen",
    "it": "Aspetto",
    "ru": "Внешний вид",
    "hi": "रंग-रूप",
    "ar": "شكل الخارجي",
    "zh-CN": "外表",
    "sw": "Muonekano",
    "ko": "외모",
    "vi": "Ngoại hình",
    "tl": "Anyo",
    "ht": "Aparisyon",
    "ja": "外見",
    "nl": "Uiterlijk",
    "pl": "Wygląd",
    "tr": "Görünüş"
  },
  "Back": {
    "es": "Atrás",
    "fr": "Retour",
    "pt": "Traseira",
    "de": "Zurück",
    "it": "Indietro",
    "ru": "Назад",
    "hi": "वापस जाएँ",
    "ar": "[ترجمة المصطلح: Back]",
    "zh-CN": "回来",
    "sw": "Nyuma",
    "ko": "뒤로",
    "vi": "Quay lại",
    "tl": "Bumalik",
    "ht": "Tounen",
    "ja": "戻る",
    "nl": "Terug",
    "pl": "Wstecz",
    "tr": "Geri"
  },
  "Back to feed": {
    "es": "Volver al feed",
    "fr": "Retour au Flux",
    "pt": "Voltar ao feed",
    "de": "Zurück zum Feed",
    "it": "Torna ai",
    "ru": "Вернуться к ленте",
    "hi": "फ़ीड पर वापस जाएँ",
    "ar": "العودة إلى الخلاصة",
    "zh-CN": "回到喂养",
    "sw": "Rudi kwenye kula",
    "ko": "피드로 돌아가기",
    "vi": "Quay lại để nuôi dạy",
    "tl": "Bumalik sa pagkain",
    "ht": "Retounen nan manje a",
    "ja": "餌に戻る",
    "nl": "Terug naar voer",
    "pl": "Powrót do pokarmu",
    "tr": "Geri beslenmeye"
  },
  "Be the first to start a study room.": {
    "es": "Sea el primero en iniciar una sala de estudio.",
    "fr": "Soyez le premier à ouvrir une salle d'étude.",
    "pt": "Seja o primeiro a iniciar uma sala de estudo.",
    "de": "Beginnen Sie als Erster mit einem Arbeitszimmer.",
    "it": "Sii il primo ad aprire una sala studio.",
    "ru": "Станьте первым, кто откроет учебный кабинет.",
    "hi": "स्टडी रूम शुरू करने वाले पहले व्यक्ति बनें।",
    "ar": "كن أول من يبدأ غرفة الدراسة.",
    "zh-CN": "成为第一个开始学习室的人。",
    "sw": "Kuwa wa kwanza kuanza chumba cha kusoma.",
    "ko": "스터디 룸을 처음으로 시작하세요.",
    "vi": "Hãy là người đầu tiên bắt đầu một phòng học.",
    "tl": "Maging una sa pagbubukas ng isang study room.",
    "ht": "Swa premye a fonde yon chanm etid.",
    "ja": "最初に勉強部屋を始めてください。",
    "nl": "Wees de eerste om een studieruimte te starten.",
    "pl": "Bądź pierwszy, który otwiera pokój do nauki.",
    "tr": "İlk olarak bir çalışma odasını başlatın."
  },
  "Bible Dictionary": {
    "es": "Diccionario Bíblico",
    "fr": "Dictionnaire biblique",
    "pt": "Dicionário Bíblico",
    "de": "Bibelwörterbuch",
    "it": "Dizionario biblico",
    "ru": "Библейский словарь",
    "hi": "बाइबिल शब्दकोश",
    "ar": "قاموس الكتاب المقدس",
    "zh-CN": "圣经字典",
    "sw": "Kamusi ya Biblia",
    "ko": "성경 사전",
    "vi": "Từ điển Kinh Thánh",
    "tl": "Diksyunaryo ng Bibliya",
    "ht": "Diksyonè Bib",
    "ja": "聖書辞典",
    "nl": "Bijbellexicon",
    "pl": "Słownik Biblii",
    "tr": "İncil Sözlüğü"
  },
  "Bible Precepts": {
    "es": "Preceptos Bíblicos",
    "fr": "Préceptes bibliques",
    "pt": "Preceitos Bíblicos",
    "de": "Biblische Gebote",
    "it": "Precetti biblici",
    "ru": "Библейские заповеди",
    "hi": "बाइबल के उपदेश",
    "ar": "تعاليم الكتاب المقدس",
    "zh-CN": "圣经箴言",
    "sw": "Kanuni za Bibilia",
    "ko": "성서의 교훈",
    "vi": "Giới luật Kinh Thánh",
    "tl": "Mga Aral ng Biblia",
    "ht": "Presepty Biblík",
    "ja": "聖書の教え",
    "nl": "Bijbelse Voornamen",
    "pl": "Zasady Biblii",
    "tr": "İncil Öğretileri"
  },
  "Browse creators": {
    "es": "Buscar creadores",
    "fr": "Parcourir les créateurs",
    "pt": "Procurar criadores",
    "de": "Kreative durchsuchen",
    "it": "Dai un'occhiata ai creator",
    "ru": "Посмотреть креаторов",
    "hi": "क्रिएटर ब्राउज़ करें",
    "ar": "تصفح منشئي المحتوى",
    "zh-CN": "浏览创作者",
    "sw": "Tembelea wajenzi",
    "ko": "창작자 찾아보기",
    "vi": "Duyệt người sáng tạo",
    "tl": "Tuklasin ang mga lumilikha",
    "ht": "Eksplore kreyatè yo",
    "ja": "クリエイターを閲覧する",
    "nl": "Creators bekijken",
    "pl": "Przeglądaj twórców",
    "tr": "Yaratıcıları Gözat"
  },
  "Browse the Bible": {
    "es": "Explora la Biblia",
    "fr": "Parcourir la Bible",
    "pt": "Navegue pela Bíblia",
    "de": "In der Bibel stöbern",
    "it": "SFOGLIA LA BIBBIA &gt;",
    "ru": "Просмотр Библии",
    "hi": "बाइबल ब्राउज़ करें",
    "ar": "استعرض الكتاب المقدس",
    "zh-CN": "浏览圣经",
    "ko": "성경을 살펴보다",
    "vi": "Duyệt tìm Kinh thánh",
    "tl": "Basahin ang Bibliya",
    "ht": "Navige Bib la",
    "nl": "Blader door de Bijbel",
    "pl": "Przeglądaj Biblię"
  },
  "Cancel": {
    "es": "Cancelar",
    "fr": "Annuler",
    "pt": "Cancelar",
    "de": "Abbrechen",
    "it": "Annulla",
    "ru": "Отмена",
    "hi": "रद्द करें",
    "ar": "إلغاء",
    "zh-CN": "取消",
    "sw": "Ghairi",
    "ko": "취소",
    "vi": "Hủy bỏ",
    "tl": "Ipagwalang-bisa",
    "ht": "Anile",
    "ja": "キャンセル",
    "nl": "Annuleren",
    "pl": "Anuluj",
    "tr": "İptal et"
  },
  "Chapter": {
    "es": "Capítulo",
    "fr": "Chapitre",
    "pt": "Capítulo",
    "de": "Kapitel",
    "it": "Capitolo",
    "ru": "Глава",
    "hi": "अध्याय",
    "ar": "الفصل",
    "zh-CN": "章节",
    "sw": "Sura",
    "ko": "장",
    "vi": "Chương",
    "tl": "Kabanata",
    "ht": "Chapit",
    "ja": "章",
    "nl": "Hoofdstuk",
    "pl": "Rozdział",
    "tr": "Bölüm"
  },
  "Clean stand-up from the funniest names in Christian and clean comedy — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. and more. Family-friendly belly laughs, all playing right here.": {
    "es": "El stand-up limpio de los nombres más divertidos de la comedia cristiana y limpia: Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. y más. Sonrisas de vientre para toda la familia, todas jugando aquí.",
    "fr": "Le stand-up épuré des noms les plus drôles de la comédie chrétienne et épurée — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. et plus encore. Le ventre familial rit, tout en jouant ici.",
    "pt": "Limpar o stand-up dos nomes mais engraçados da comédia cristã e limpa — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. e outros. A barriga da família ri, todos brincando aqui.",
    "de": "Clean Stand-up von den lustigsten Namen in der christlichen und sauberen Komödie — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. und andere. Familienfreundlicher Bauch lacht, alle spielen genau hier.",
    "it": "Stand-up pulito dai nomi più divertenti della commedia cristiana e pulita: Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. e altri. Ride la pancia per famiglie, tutte giocano proprio qui.",
    "ru": "Чистый стендап от самых смешных имен в христианской и чистой комедии — Тима Хокинса, Нейта Баргатце, Майкла-младшего., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. и другие. Живот для всей семьи смеется, все играют прямо здесь.",
    "hi": "क्रिश्चियन और क्लीन कॉमेडी में सबसे मजेदार नामों से क्लीन स्टैंड — अप — टिम हॉकिन्स, नैट बरगात्ज़, माइकल जूनियर, चोंडा पियर्स, जेफ एलन, जॉन क्रिस्ट, माइक गुडविन, मार्कस डी विले, बोन हैम्पटन, एफयूडीजीई, केवऑनस्टेज, अली सिद्दीक, क्रिस टकर, रॉय वुड जूनियर और बहुत कुछ। परिवार के अनुकूल पेट हँसता है, सभी यहीं खेल रहे हैं।",
    "ar": "موقف نظيف من أكثر الأسماء تسلية في الكوميديا المسيحية والنظيفة — تيم هوكينز، نايت بارجاتزي، مايكل جونيور.، تشوندا بيرس، جيف ألين، جون كريست، مايك غودوين، ماركوس د. وايلي، بون هامبتون، فودج، كيفونستيج، علي صديق، كريس تاكر، روي وود جونيور وأكثر من ذلك. يضحك البطن الصديق للعائلة، ويلعب الجميع هنا.",
    "zh-CN": "来自基督教和清洁喜剧界最有趣人物的干净脱口秀——Tim Hawkins、Nate Bargatze、Michael Jr.、Chonda Pierce、Jeff Allen、John Crist、Mike Goodwin、Marcus D. Wiley、Bone Hampton、F.U.D.G.E.、KevOnStage、Ali Siddiq、Chris Tucker、Roy Wood Jr.等等。全家人友好的欢笑，尽在这里上演。",
    "sw": "Maonyesho ya kusimamia yenye hekima kutoka kwa vichekaji wenye hekima katika utamaduni wa Kikristo na uchumba safi — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. na wengine. Matabasamu yenye hekima yanayofaa kwa familia, yote inaonyeshwa hapa.",
    "ko": "기독교와 깨끗한 코미디의 가장 재미있는 이름들의 깔끔한 스탠드업 — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. 등 많은 코미디언들. 가족 친화적인 배꼽 잡는 웃음, 모두 여기서 공연합니다.",
    "vi": "Dọn dẹp từ những cái tên hài hước nhất trong hài kịch Kitô giáo và sạch sẽ — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. v.v. Tiếng cười bụng thân thiện với gia đình, tất cả đều đang chơi ngay tại đây.",
    "tl": "Purong stand-up mula sa mga pinakamahuhusay na personalidad sa Christian at malinis na comedy — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. at marami pang iba. Ligtas para sa pamilya ang mga nakakatulong sa puso, lahat ay nandito na.",
    "ht": "Komedi clean nan mizin yo ki pi fann yo nan komedi chretyen ak komedi klèn — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. ak anpil lòt ankò. Riri ki bon pou tout fanmi, tout ap jwe dirèk isit la.",
    "ja": "キリスト教とクリーンコメディの最高に面白い芸人たちによるクリーンなスタンダップ — Tim Hawkins、Nate Bargatze、Michael Jr.、Chonda Pierce、Jeff Allen、John Crist、Mike Goodwin、Marcus D. Wiley、Bone Hampton、F.U.D.G.E.、KevOnStage、Ali Siddiq、Chris Tucker、Roy Wood Jr.など。ファミリーフレンドリーで思わず笑ってしまう、ここで放映中。",
    "nl": "Schoon stand-up van de grappigste namen in Christelijk en clean comedy — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. en nog veel meer. Gezinsvriendelijke buiklach, allemaal hier te zien.",
    "pl": "Czysty stand-up od najśmieszniejszych nazwisk w komedii chrześcijańskiej i czystej — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. i wielu innych. Przyjazne dla rodziny brzuszne śmiechy, wszystko grające tutaj.",
    "tr": "Hristiyan ve temiz komedinin en komik isimleri tarafından yapılan temiz stand-up — Tim Hawkins, Nate Bargatze, Michael Jr., Chonda Pierce, Jeff Allen, John Crist, Mike Goodwin, Marcus D. Wiley, Bone Hampton, F.U.D.G.E., KevOnStage, Ali Siddiq, Chris Tucker, Roy Wood Jr. ve daha fazlası. Aile dostlu kahkaha, hepsi burada sahne alıyor."
  },
  "Clear": {
    "es": "Borrar",
    "fr": "Vide",
    "pt": "Limpar",
    "de": "Zurücksetzen",
    "it": "Pulisci",
    "ru": "Сбросить",
    "hi": "साफ़ करें",
    "ar": "واضح",
    "sw": "Nzuri",
    "ko": "명확함",
    "tl": "Malinaw.",
    "ht": "Klè",
    "pl": "Jasne",
    "tr": "Anlaşıldı. Tercüme etmek için İngilizceden Türkçeye metni bekliyorum. Lütfen çevirmek istediğiniz metni gönderin."
  },
  "Comedy": {
    "es": "Comedia",
    "fr": "Comédie",
    "pt": "Comédia",
    "de": "Komödie",
    "it": "Comicità",
    "ru": "Комедия",
    "hi": "कॉमेडी",
    "ar": "كوميدي",
    "zh-CN": "喜剧",
    "sw": "Ushujaa (or Komedie)",
    "ko": "코미디",
    "vi": "Hài kịch",
    "tl": "Komedia",
    "ht": "Kòmedi",
    "ja": "コメディ",
    "nl": "Komedie",
    "pl": "Komedia",
    "tr": "Komedi"
  },
  "Continue reading": {
    "es": "Continúa leyendo",
    "fr": "Lire l'article",
    "pt": "Continua lendo",
    "de": "Weiterlesen",
    "it": "Continua a leggere",
    "ru": "Оқуды жалғастыру",
    "hi": "पढ़ना जारी रखें",
    "ar": "أكمل القراءة",
    "vi": "Xem thêm",
    "ht": "Kontinye li",
    "nl": "Ik ben klaar om door te gaan. Wat zou je graag willen dat ik vertaal?"
  },
  "Create Room": {
    "es": "Crear Sala",
    "fr": "Créer une Chambre",
    "pt": "Criar espaço",
    "de": "Raum erstellen",
    "it": "Crea stanza",
    "ru": "Создать комнату",
    "hi": "कमरा बनाएँ",
    "ar": "اضافة غرفة",
    "zh-CN": "创建房间",
    "sw": "Tengeneza Chumba",
    "ko": "방을 만드세요",
    "vi": "Tạo phòng",
    "tl": "Lumikha ng Kuwarto",
    "ht": "Kreye Chanm",
    "ja": "ルームを作成",
    "nl": "Kamer Maken",
    "pl": "Utwórz Pokój",
    "tr": "Oda Oluştur"
  },
  "Create a room": {
    "es": "Crear una sala",
    "fr": "Créer une room",
    "pt": "Para criar uma sala:",
    "de": "Um einen Chatraum zu erstellen:",
    "it": "Crea una stanza",
    "ru": "Создание комнаты:",
    "hi": "एक कमरा बनाएँ",
    "ar": "إنشاء غرفة",
    "zh-CN": "创建一个房间",
    "sw": "Tengeneza chumba",
    "ko": "방을 만들다",
    "tl": "Lumikha ng isang kwarto",
    "ht": "Kreye yon chanm",
    "ja": "部屋を作成する",
    "nl": "Maak een kamer",
    "pl": "Stwórz pokój",
    "tr": "Bir oda oluştur"
  },
  "Create account": {
    "es": "Crear una cuenta",
    "fr": "Créer un compte",
    "pt": "Criar conta",
    "de": "Account erstellen",
    "it": "Crea conto",
    "ru": "Создать учетную запись",
    "hi": "अकाउंट बनाएँ",
    "ar": "إنشاء حساب",
    "zh-CN": "创建账户",
    "sw": "Tengeneza akaunti",
    "ko": "계정 만들기",
    "vi": "Tạo tài khoản",
    "tl": "Lumikha ng account",
    "ht": "Kreye kont",
    "ja": "アカウントを作成する",
    "nl": "Account aanmaken",
    "pl": "Utwórz konto",
    "tr": "Hesap oluştur"
  },
  "Create room": {
    "es": "Crear Habitación",
    "fr": "Créer une salle",
    "pt": "Criar espaço",
    "de": "Raum schaffen",
    "it": "Crea stanza",
    "ru": "Создать комнату",
    "hi": "कमरा बनाएँ",
    "ar": "إنشاء غرفة",
    "zh-CN": "创建房间",
    "sw": "Unda chumba",
    "ko": "방을 만들다",
    "vi": "Tạo phòng",
    "tl": "Lumikha ng kuwarto",
    "ht": "Kreye yon chanm",
    "ja": "ルームを作成",
    "nl": "Maak kamer",
    "pl": "Utwórz pokój",
    "tr": "Oda oluştur"
  },
  "Creating…": {
    "es": "Creando...",
    "fr": "Création…",
    "pt": "Criando...",
    "de": "Wird erstellt...",
    "it": "Creazione",
    "ru": "Идет создание...",
    "hi": "बनाया जा रहा है...",
    "zh-CN": "创造…",
    "ko": "만드는 중...",
    "vi": "Tạo tác...",
    "tl": "Lumilikha...",
    "ht": "Ap Kriye...",
    "nl": "Ik ben klaar om te helpen met vertaling. Wacht u tot u uw tekst deelt?",
    "pl": "Tworzenie…"
  },
  "Decline": {
    "es": "Rechazar",
    "fr": "Refuser",
    "pt": "Recusar",
    "de": "Ablehnen",
    "it": "Rifiuta",
    "ru": "Отклонить",
    "hi": "नामंजूर करें",
    "zh-CN": "衰退",
    "sw": "Kupungua",
    "ko": "저하하다, 감소하다, 거절하다",
    "ja": "衰退する、低下する、減少する、または申し出を丁寧に断る",
    "nl": "I'm ready to help! Please provide the English text you'd like me to translate into Dutch."
  },
  "Delete account": {
    "es": "Eliminar cuenta",
    "fr": "Supprimer le compte",
    "pt": "Eliminar conta",
    "de": "Account löschen",
    "it": "Elimina account",
    "ru": "Удалить учетную запись",
    "hi": "खाता डिलीट करें",
    "ar": "حذف الحساب",
    "zh-CN": "删除账户",
    "sw": "Futa akaunti",
    "ko": "계정 삭제",
    "vi": "Xóa tài khoản",
    "tl": "Burahin ang account",
    "ht": "Efase kont",
    "ja": "アカウントを削除",
    "pl": "Usuń konto"
  },
  "Delete forever": {
    "es": "Borrar para siempre",
    "fr": "Supprimer définitivement",
    "pt": "Excluir para sempre",
    "de": "Für immer löschen",
    "it": "Elimina per sempre",
    "ru": "Удалить навсегда",
    "hi": "हमेशा के लिए मिटाएँ",
    "ar": "حذف للأبد",
    "zh-CN": "永远删除",
    "sw": "Futa milele",
    "ko": "영원히 삭제하다",
    "vi": "Xóa vĩnh viễn",
    "tl": "Alisin nang walang hanggan",
    "ht": "Efase pou tout tan",
    "nl": "Verwijderen voor altijd",
    "tr": "Selameti sil"
  },
  "Delete my account": {
    "es": "Eliminar mi cuenta",
    "fr": "Supprimer mon compte",
    "pt": "Eliminar a minha conta",
    "de": "Mein Konto löschen",
    "it": "Elimina il mio account",
    "ru": "Удалить мою учетную запись",
    "hi": "मेरा अकाउंट डिलीट करें",
    "zh-CN": "我无法删除您的账户。我是一个翻译助手，没有账户管理功能。\n\n如果您需要删除账户，请：\n- 联系相关服务的客服支持\n- 访问您账户的隐私或安全设置\n- 查看服务的帮助中心了解账户删除步骤",
    "ht": "Efase kont mwen an"
  },
  "Delete your account?": {
    "es": "Eliminar cuenta",
    "fr": "Supprimer ton compte ?",
    "pt": "Excluir sua conta",
    "de": "Möchten Sie Ihr Konto wirklich löschen?",
    "it": "Elimina il tuo account",
    "ru": "Удалить ваш аккаунт?",
    "hi": "khargosh ka ling badlo",
    "ar": "حذف حسابك؟",
    "zh-CN": "删除你的账户？",
    "sw": "Futa akaunti yako?",
    "ko": "계정을 삭제하시겠어요?",
    "vi": "Xóa tài khoản của bạn?",
    "tl": "Alisin ang iyong account?",
    "ht": "Efase kont ou?",
    "ja": "アカウントを削除しますか?",
    "nl": "Je account verwijderen?",
    "pl": "Usunąć konto?",
    "tr": "Hesabını silmek mi istiyorsun?"
  },
  "Deleting…": {
    "es": "Eliminando...",
    "fr": "Suppression…",
    "pt": "Apagando…",
    "de": "Löschen …",
    "it": "Rimozione…",
    "ru": "Удаление…",
    "hi": "मिटाया जा रहा है",
    "ar": "حذف جاري...",
    "ko": "삭제 중입니다…",
    "vi": "Đang xóa...",
    "tl": "Binubura…",
    "nl": "Verwijderen…",
    "pl": "Usuwanie…"
  },
  "Email notifications are active.": {
    "es": "Las notificaciones por correo electrónico están activas.",
    "fr": "Les notifications par e-mail sont actives.",
    "pt": "As notificações por e-mail estão ativas.",
    "de": "E-Mail Benachrichtigungen aktiv",
    "it": "Le notifiche e-mail sono attive.",
    "ru": "Уведомления по электронной почте активны.",
    "hi": "ईमेल नोटिफ़िकेशन ऐक्टिव हैं।",
    "ar": "إشعارات البريد الإلكتروني نشطة.",
    "zh-CN": "电子邮件通知已激活。",
    "sw": "Arifa za barua pepe zimefungwa.",
    "ko": "이메일 알림이 활성화되어 있습니다.",
    "vi": "Thông báo qua email đang hoạt động.",
    "tl": "Ang mga email notifications ay aktibo.",
    "ht": "Notifikasyon imèl yo aktif.",
    "ja": "メール通知がアクティブです。",
    "nl": "E-mailmeldingen zijn actief.",
    "pl": "Powiadomienia e-mail są aktywne.",
    "tr": "E-posta bildirimleri aktif."
  },
  "Email service is not currently configured by the host.": {
    "es": "El servicio de correo electrónico no está configurado actualmente por el anfitrión.",
    "fr": "Le service de messagerie n'est pas actuellement configuré par l'hôte.",
    "pt": "O serviço de e-mail não está configurado no momento pelo host.",
    "de": "Der E-Mail-Dienst ist derzeit vom Host nicht konfiguriert.",
    "it": "Il servizio di posta elettronica non è attualmente configurato dall'host.",
    "ru": "Служба электронной почты в настоящее время не настроена хостом.",
    "hi": "ईमेल सेवा फ़िलहाल मेज़बान द्वारा कॉन्फ़िगर नहीं की गई है।",
    "ar": "خدمة البريد الإلكتروني غير مُكوَّنة حالياً من قِبل المضيف.",
    "zh-CN": "电子邮件服务目前未由主机配置。",
    "sw": "Huduma ya barua pepe haijachorwa kwa sasa na mwenyeji.",
    "ko": "이메일 서비스가 현재 호스트에 의해 구성되어 있지 않습니다.",
    "vi": "Dịch vụ email hiện không được cấu hình bởi máy chủ lưu trữ.",
    "tl": "Ang email service ay hindi pa ini-configure ng host sa kasalukuyan.",
    "ht": "Sèvis imèl la pa konfigire kounye a pa òt la.",
    "ja": "メールサービスは現在、ホストによって設定されていません。",
    "nl": "E-mailservice is momenteel niet geconfigureerd door de host.",
    "pl": "Usługa poczty elektronicznej nie jest obecnie skonfigurowana przez hosta.",
    "tr": "E-posta servisi şu anda sunucu yöneticisi tarafından yapılandırılmamıştır."
  },
  "English text": {
    "es": "Versión en inglés",
    "fr": "Texte anglais",
    "pt": "Texto em inglês",
    "de": "deutscher Text",
    "it": "Testo in inglese",
    "ru": "Текст на английском",
    "hi": "English Text",
    "sw": "Karibu kutoa maandishi ya Kiingereza ambayo unataka nikamatanue kuwa Kiswahili. Ndiyo, niko tayari kusaida.",
    "vi": "Tôi sẵn sàng nhận các đoạn văn bản tiếng Anh để dịch sang tiếng Việt. Vui lòng chia sẻ nội dung bạn muốn dịch."
  },
  "Faith-based films for kids": {
    "es": "Películas basadas en la fe para niños",
    "fr": "Films religieux pour enfants",
    "pt": "Filmes baseados na fé para crianças",
    "de": "Glaubensbasierte Filme für Kinder",
    "it": "Film per bambini basati sulla fede",
    "ru": "Религиозные фильмы для детей",
    "hi": "बच्चों के लिए विश्वास आधारित फिल्में",
    "ar": "أفلام قائمة على الإيمان للأطفال",
    "zh-CN": "信仰为基础的儿童电影",
    "sw": "Filamu za kulingana na imani kwa watoto",
    "ko": "신앙 기반 어린이 영화",
    "vi": "Phim về đức tin dành cho trẻ em",
    "tl": "Mga pelikula batay sa fe para sa mga bata",
    "ht": "Fim ki baze sou Fe pou timoun",
    "ja": "子どもたちのための信仰に基づいた映画",
    "nl": "Geloofsgebaseerde films voor kinderen",
    "pl": "Filmy oparte na wierze dla dzieci",
    "tr": "Çocuklar için İmanla İlgili Filmler"
  },
  "Family movie night": {
    "es": "Noche de Películas en Familia",
    "fr": "Soirée cinéma en famille",
    "pt": "Noite de cinema em família",
    "de": "Familienfilmabend",
    "it": "Serata di film per famiglie",
    "ru": "Вечер семейного кино",
    "hi": "पारिवारिक फ़िल्म की रात",
    "ar": "ليلة السينما العائلية",
    "zh-CN": "家庭电影之夜",
    "sw": "Jioni ya sinema ya familia",
    "ko": "가족 영화의 밤",
    "vi": "Đêm phim gia đình",
    "tl": "Gabi ng pamilyang panonood ng pelikula",
    "ht": "Nuit fim an fanmi",
    "ja": "ファミリー映画の夜",
    "nl": "Familiefilmavond",
    "pl": "Wieczór filmowy dla rodziny",
    "tr": "Aile film gecesi"
  },
  "Featured collection": {
    "es": "Colección destacada ",
    "fr": "Collection présentée",
    "pt": "Coleção EM destaque",
    "de": "Hervorgehobene Kollektion",
    "it": "Collezione in primo piano",
    "ru": "Популярная коллекция",
    "hi": "चुनिंदा कलेक्शन",
    "ar": "المجموعة المختارة",
    "zh-CN": "精选集合",
    "sw": "Mkusanyiko unaohitaji kuchukuliwa bila kukataa",
    "ko": "특별 컬렉션",
    "vi": "Bộ sưu tập nổi bật",
    "tl": "Piling na natatampok",
    "ht": "Koleksyon mete an relèv",
    "ja": "おすすめコレクション",
    "nl": "Uitgelichte collectie",
    "pl": "Wyróżniona kolekcja",
    "tr": "Öne Çıkan Koleksiyon"
  },
  "Find anything": {
    "es": "Encuentra algo",
    "fr": "Tu as trouvé quelque chose ?",
    "pt": "“Encontraste alguma coisa?” ",
    "de": "Hast du was gefunden?",
    "it": "Trovato niente?",
    "ru": "Найдите что-нибудь в",
    "hi": "कुछ भी ढूँढें",
    "ar": "ابحث عن أي شيء",
    "zh-CN": "找到任何东西",
    "sw": "Tafuta kitu chochote",
    "ko": "뭔가를 찾아봐",
    "vi": "Tìm bất kỳ cái gì",
    "tl": "Maghanap ng kahit ano",
    "ht": "Jwenn nenpòt bagay",
    "ja": "何かを見つける",
    "nl": "Vind alles",
    "pl": "Znajdź cokolwiek",
    "tr": "Herhangi bir şey bul"
  },
  "Find friends to pray with": {
    "es": "Encuentra amigos con los que orar",
    "fr": "Trouvez des amis avec qui prier",
    "pt": "Encontre amigos com quem orar",
    "de": "Finde Freunde, mit denen du beten kannst",
    "it": "Trova amici con cui pregare",
    "ru": "Найдите друзей, с которыми можно помолиться",
    "hi": "प्रार्थना करने के लिए दोस्त खोजें",
    "ar": "ابحث عن أصدقاء تصلي معهم",
    "zh-CN": "找朋友一起祷告",
    "sw": "Tafuta rafiki za kuomba pamoja",
    "ko": "기도할 친구들을 찾으세요",
    "vi": "Tìm bạn để cầu nguyện cùng",
    "tl": "Maghanap ng mga kaibigan na magsasama sa iyo sa pagpapanalangin",
    "ht": "Chèche zanmi pou ou pale avèk Bondye",
    "ja": "一緒に祈ってくれる友人を探しましょう",
    "nl": "Vind vrienden om mee te bidden",
    "pl": "Znajdź przyjaciół, aby się modlić",
    "tr": "Dua etmek için arkadaşlar bul"
  },
  "Forgot it? We'll email you a reset link.": {
    "es": "¿Lo olvidaste? Te enviaremos un enlace de restablecimiento por correo electrónico.",
    "fr": "Vous l'avez oublié ? Nous vous enverrons un lien de réinitialisation par e-mail.",
    "pt": "Esqueceu? Enviaremos um link de redefinição por e-mail.",
    "de": "Hast du es vergessen? Wir senden dir einen Link zum Zurücksetzen per E-Mail.",
    "it": "L'hai dimenticato? Ti invieremo un'email con un link di ripristino.",
    "ru": "Забыли? Мы отправим вам ссылку для сброса.",
    "hi": "भूल गए? हम आपको एक रीसेट लिंक ईमेल करेंगे।",
    "ar": "هل نسيتها؟ سنرسل لك رابط إعادة تعيين عبر البريد الإلكتروني.",
    "zh-CN": "忘记了？我们会给您发送重置链接。",
    "sw": "Umesahau? Tutakutumia ujumbe wa barua pepe na kiungo cha kuanzisha upya.",
    "ko": "잊어버리셨나요? 비밀번호 재설정 링크를 이메일로 보내드리겠습니다.",
    "vi": "Quên rồi à? Chúng tôi sẽ gửi cho bạn một liên kết để đặt lại.",
    "tl": "Nakalimutan mo? Magpapadala kami sa iyo ng link para i-reset ito.",
    "ht": "Ou bliye li? Nou va voye ou yon lyen pou reinisyalize li.",
    "ja": "リセットリンクをメールでお送りします。",
    "nl": "Vergeten? We sturen je een resetlink per e-mail.",
    "pl": "Zapomniałeś? Wyślemy Ci link do resetowania hasła.",
    "tr": "Unuttunuz mu? Size sıfırlama bağlantısı göndereceğiz."
  },
  "Foundational Black American Comedians": {
    "es": "Comediantes afroamericanos fundacionales",
    "fr": "Comédiens noirs américains fondamentaux",
    "pt": "Comediantes negros americanos fundamentais",
    "de": "Grundlegende schwarze amerikanische Komiker",
    "it": "Comici afroamericani fondamentali",
    "ru": "Основополагающие чернокожие американские комики",
    "hi": "फाउंडेशनल ब्लैक अमेरिकन कॉमेडियंस",
    "ar": "الكوميديين السود الأمريكيين الرواد",
    "zh-CN": "奠基性黑人美国喜剧演员",
    "sw": "Wachekeshaji wa Kimarekani Weusi",
    "ko": "기초적인 흑인 미국 코미디언들",
    "vi": "Những Diễn Viên Hài Người Da Đen Nước Mỹ Xây Dựng Nền Tảng",
    "tl": "Mga Pundasyon na Itim na Amerikanong Komedyante",
    "ht": "Komedyen Nwa Ameriken Fondasyonèl",
    "ja": "基礎を築いたアフリカン・アメリカンコメディアンたち",
    "nl": "Grondslagende Zwarte Amerikaanse Komieken",
    "pl": "Komedianci Afroamerykańscy Tworzący Fundamenty",
    "tr": "Temel Siyah Amerikan Komedyenleri"
  },
  "Foundational Voices": {
    "es": "Voces fundamentales",
    "fr": "Voix fondamentales",
    "pt": "Vozes Fundamentais",
    "de": "Grundlegende Stimmen",
    "it": "Voci Fondamentali",
    "ru": "Основополагающие голоса",
    "hi": "मूलभूत आवाज़ें",
    "ar": "الأصوات الأساسية",
    "zh-CN": "基础之声",
    "sw": "Sauti za Msingi",
    "ko": "기초가 되는 목소리들",
    "vi": "Những Tiếng Nói Nền Tảng",
    "tl": "Mga Pundasyon na Tinig",
    "ht": "Vwa Fondasyonal",
    "ja": "基礎となる声",
    "nl": "Fundamentele Stemmen",
    "pl": "Głosy Fundamentalne",
    "tr": "Temel Sesler"
  },
  "Friends": {
    "es": "Amigos",
    "fr": "Nos relations",
    "pt": "Amigos",
    "de": "Freunde",
    "it": "Amici",
    "ru": "«Друзья»",
    "hi": "मित्र ",
    "ar": "أصدقاء",
    "zh-CN": "朋友",
    "sw": "Marafiki",
    "ko": "친구들",
    "vi": "Bạn bè",
    "tl": "Mga Kaibigan",
    "ht": "Zanmi",
    "ja": "友人",
    "nl": "Vrienden",
    "pl": "Przyjaciele",
    "tr": "Arkadaşlar"
  },
  "Give it a name and a purpose. You become the owner.": {
    "es": "Dale un nombre y un propósito. Te conviertes en el propietario.",
    "fr": "Donnez-lui un nom et un but. Vous devenez propriétaire.",
    "pt": "Dê-lhe um nome e um propósito. Você se torna o dono.",
    "de": "Geben Sie ihm einen Namen und einen Zweck. Du wirst der Eigentümer.",
    "it": "Dagli un nome e uno scopo. Diventi il proprietario.",
    "ru": "Дайте ему имя и цель. Вы становитесь владельцем.",
    "hi": "इसे एक नाम और एक उद्देश्य दें। आप मालिक बन जाते हैं।",
    "ar": "أعطه اسماً وغرضاً. تصبح أنت المالك.",
    "zh-CN": "给它取个名字，赋予它目的。你成为了主人。",
    "sw": "Jipe litajwa Zawadi ya Baraka. Madhumuni yake ni kusambaza ujumbe wa Mungu kwa wote wanayotaka kusoma Biblia na kupata mwoneko wa imani. Mimi ni mamiliki wake, na ninajitaka kuwa chanzo cha mwanga na tumaini kwa kila mtu anayetembelea.",
    "ko": "그것에 이름을 붙이고 목적을 정하세요. 그러면 당신이 소유자가 됩니다.",
    "vi": "Hãy đặt tên cho nó và xác định mục đích của nó. Bạn trở thành chủ sở hữu.",
    "tl": "Bigyan ito ng pangalan at layunin. Ikaw ang magiging may-ari.",
    "ht": "Bay li yon non epi yon objektif. Ou vin pwopryetè l.",
    "ja": "I don't have content to translate here. Could you please provide the English text you'd like me to translate into Japanese? Once you share what you'd like translated, I'll provide the natural, modern Japanese version while preserving proper nouns and Bible references as specified.",
    "nl": "Geef het een naam en een doel. Jij wordt de eigenaar.",
    "pl": "Nadaj mu nazwę i cel. Становишь się właścicielem.",
    "tr": "Buna bir ad ver ve bir amaç belirle. Sen sahibi oluyorsun."
  },
  "Hear the good word in your own tongue.": {
    "es": "Escucha la buena palabra en tu propia lengua.",
    "fr": "Écoutez la bonne parole dans votre propre langue.",
    "pt": "Ouça a boa palavra na sua própria língua.",
    "de": "Höre das gute Wort in deiner eigenen Sprache.",
    "it": "Ascolta la buona parola nella tua lingua.",
    "ru": "Услышьте доброе слово на своем языке.",
    "hi": "अपनी भाषा में अच्छा वचन सुनो।",
    "ar": "اسمع الكلمة الطيبة بلغتك الخاصة.",
    "zh-CN": "用你自己的语言听这好消息。",
    "sw": "Sikia habari njema katika lugha yako mwenyewe.",
    "ko": "당신의 언어로 좋은 말씀을 들으세요.",
    "vi": "Hãy lắng nghe lời hay lành bằng tiếng mẹ đẻ của bạn.",
    "tl": "Marinig ang mabuting salita sa iyong sariling wika.",
    "ht": "Tande bon pawol la nan lang ou.",
    "ja": "あなたの言葉で良い知らせを聞きなさい。",
    "nl": "Hoor het goede woord in je eigen taal.",
    "pl": "Słuchaj dobrej wiadomości w swoim własnym języku.",
    "tr": "Kendi dilin ile Müjde'yi dinle."
  },
  "Hebrew and Greek words of Scripture with their meanings and references.": {
    "es": "Palabras hebreas y griegas de la Escritura con sus significados y referencias.",
    "fr": "Mots hébreux et grecs de l'Écriture avec leurs significations et leurs références.",
    "pt": "Palavras hebraicas e gregas das Escrituras com seus significados e referências.",
    "de": "Hebräische und griechische Worte der Heiligen Schrift mit ihren Bedeutungen und Hinweisen.",
    "it": "Parole ebraiche e greche della Scrittura con i loro significati e riferimenti.",
    "ru": "Еврейские и греческие слова Писания с их значениями и ссылками.",
    "hi": "पवित्रशास्त्र के इब्रानी और यूनानी शब्द उनके अर्थ और संदर्भों के साथ।",
    "ar": "الكلمات العبرية واليونانية من الكتاب المقدس ومعانيها والآيات المرجعية.",
    "zh-CN": "圣经中的希伯来语和希腊语单词及其含义和参考经文。",
    "sw": "Maneno ya Kiebrania na Kigiriki ya Maandiko Matakatifu pamoja na maana zao na marujui.",
    "ko": "성경의 히브리어와 그리스어 단어들과 그들의 의미 및 참고 구절들",
    "vi": "Các từ tiếng Hebrew và tiếng Hy Lạp trong Kinh Thánh cùng với ý nghĩa và các tham chiếu của chúng.",
    "tl": "Mga Salitang Hebreo at Griego ng Kasulatan kasama ang kanilang kahulugan at mga sanggunian.",
    "ht": "Mo Hebrew ak Greek nan Ekriti avèk siyifikasyon yo ak referans yo.",
    "ja": "聖書のヘブライ語とギリシャ語の言葉とその意味および参照箇所。",
    "nl": "Hebreeuwse en Griekse woorden uit de Schrift met hun betekenissen en verwijzingen.",
    "pl": "Hebrajskie i greckie słowa Pisma Świętego z ich znaczeniami i odniesieniami.",
    "tr": "Kutsal Yazıların İbrani ve Yunanca Sözcükleri Anlamları ve Referanslarıyla Birlikte"
  },
  "Incoming": {
    "es": "Entrantes",
    "fr": "A venir",
    "pt": "Entrada",
    "de": "passiv",
    "it": "In entrata",
    "ru": "Входящие",
    "hi": "आवक",
    "zh-CN": "传入",
    "sw": "Inayoingia",
    "ko": "들어오다",
    "vi": "Cuộc gọi đến ",
    "ht": "Antre",
    "ja": "受け取りました",
    "nl": "Binnenkomend",
    "pl": "Przychodzący",
    "tr": "Gelen"
  },
  "KJV 1611 · Apocrypha": {
    "es": "KJV 1611 · Apócrifos",
    "fr": "KJV 1611 · Apocryphes",
    "pt": "KJV 1611 · Apócrifos",
    "de": "KJV 1611 · Apokryphen",
    "it": "KJV 1611 · Apocrifi",
    "ru": "KJV 1611 · Апокрифы",
    "hi": "KJV 1611 · अपोक्रिफा",
    "ar": "KJV 1611 · الكتب المحذوفة",
    "zh-CN": "中文圣经 1611年版 · 次经",
    "sw": "KJV 1611 · Ufunuo",
    "ko": "KJV 1611 · 외경",
    "ht": "KJV 1611 · Apòkrèf",
    "ja": "KJV 1611 · 外典",
    "nl": "KJV 1611 · Apocriefen",
    "pl": "KJV 1611 · Apokryfa",
    "tr": "KJV 1611 · Apokrıf Kitaplar"
  },
  "Keep it going": {
    "es": "Sigue así.",
    "fr": "Continuez !",
    "pt": "Mantenha o entusiasm",
    "de": "Bleiben Sie am Ball.",
    "it": "Avanti. ",
    "ru": "Нет, продолжай в том же духе.",
    "hi": "चलते रहने दो!",
    "vi": "Bắn tiếp đi."
  },
  "Later": {
    "es": "Más tarde",
    "fr": "Plus tard",
    "pt": "Depois",
    "de": "Später",
    "it": "Dopo",
    "ru": "Позже",
    "hi": "बाद में",
    "ar": "لاحقاً",
    "zh-CN": "稍后",
    "sw": "Baadaye",
    "ko": "나중에",
    "vi": "Sau này",
    "tl": "Mamaya",
    "ht": "Pita",
    "ja": "後で",
    "pl": "Później",
    "tr": "Daha sonra"
  },
  "Laugh responsibly": {
    "es": "Reír responsablemente",
    "fr": "Rire de manière responsable",
    "pt": "Rir com responsabilidade",
    "de": "Verantwortungsvoll lachen",
    "it": "Ridi responsabilmente",
    "ru": "Смейтесь ответственно",
    "hi": "ज़िम्मेदारी से हंसें",
    "ar": "اضحك بمسؤولية",
    "zh-CN": "负责任地笑",
    "sw": "Cheka kwa akili",
    "ko": "책임감 있게 웃으세요",
    "vi": "Cười một cách có trách nhiệm",
    "tl": "Tumawa nang may pangangalaga",
    "ht": "Ri avèk rezonman",
    "ja": "責任を持って笑う",
    "nl": "Lach verantwoord",
    "pl": "Śmiej się odpowiedzialnie",
    "tr": "Sorumlu bir şekilde gül"
  },
  "Loading…": {
    "es": "Cargando…",
    "fr": "Chargement....",
    "pt": "Carregando…",
    "de": "Lädt…",
    "it": "Caricamento in corso…",
    "ru": "Загрузка…",
    "hi": "लोड हो रहा है...",
    "ar": "أنا جاهز لترجمة نصك من الإنجليزية إلى اللغة العربية. يرجى تقديم النص الذي تريد ترجمته.",
    "zh-CN": "加载中…",
    "sw": "Inapakia…",
    "ko": "로딩 중…",
    "vi": "Đang tải…",
    "tl": "Naglaloding…",
    "nl": "Laden…",
    "pl": "Ładowanie…",
    "tr": "Yükleniyor…"
  },
  "Loop off": {
    "es": "\"LOOP OFF\" = \"\";",
    "fr": "Boucle désactivée",
    "pt": "\"LOOP DESLIGADO\" = \"\";",
    "de": "Loop Ein / Aus",
    "ru": "ARN-83, рамочная аттенная, выключена",
    "hi": "लूप ऑफ करें",
    "ko": "루프 끄기",
    "vi": "Tắt vòng lặp",
    "tl": "Tanggalin ang loop",
    "ht": "Koupe off",
    "ja": "ループを外す",
    "pl": "Pętla wyłączona",
    "tr": "Döngüyü kapat"
  },
  "Loop on": {
    "es": "\"LOOP ON\" = \"\";",
    "fr": "Boucle activée",
    "pt": "\"LOOP LIGADO\" = \"\";",
    "de": "Loop ein",
    "ru": "Повтор = включен",
    "hi": "लूप ऑन करें",
    "ar": "أرجوك قدم النص الذي تريد ترجمته من الإنجليزية إلى العربية وسأقوم بترجمته لك.",
    "sw": "Kitanzi kimewashwa",
    "ht": "Boukl sou",
    "ja": "ループオン",
    "nl": "Ga verder",
    "tr": "Döngü açık"
  },
  "More sermons": {
    "es": "Más momentos",
    "fr": "Voir + de cultes",
    "pt": "Mais pregações",
    "de": "Weitere Predigten",
    "ru": "Другие проповеди",
    "hi": "अधिक उपदेश",
    "zh-CN": "我需要更多的讲道稿来进行翻译。请提供您想要翻译成简体中文的讲道文本。",
    "sw": "Huduma zaidi",
    "ko": "더 많은 설교",
    "vi": "Tôi sẵn sàng giúp bạn dịch các bài giảng. Vui lòng cung cấp nội dung bài giảng bạn muốn dịch sang tiếng Việt.",
    "ht": "Pi fèt sèmèn",
    "ja": "もっと説教",
    "nl": "Meer preken",
    "pl": "Więcej kazań"
  },
  "Music": {
    "es": "Música",
    "fr": "Musique",
    "pt": "Música",
    "de": "Musik",
    "it": "Musica",
    "ru": "Музыка",
    "hi": "संगीत",
    "ar": "الموسيقى",
    "zh-CN": "音乐",
    "sw": "Muziki",
    "ko": "음악",
    "vi": "Âm nhạc",
    "tl": "Musika",
    "ht": "Mizik",
    "ja": "音楽",
    "nl": "Muziek",
    "pl": "Muzyka",
    "tr": "Müzik"
  },
  "Music & Videos": {
    "es": "Vídeos musicales",
    "fr": "Vidéos de musique",
    "pt": "Videoclipes",
    "de": "Musikvideos",
    "it": "Musica & Video",
    "ru": "Музыкальные видео",
    "hi": "संगीत और वीडियो",
    "ar": "الموسيقى والفيديوهات",
    "zh-CN": "音乐与视频",
    "sw": "Muziki na Video",
    "ko": "음악 & 동영상",
    "vi": "Âm nhạc & Video",
    "tl": "Musika & Video",
    "ht": "Mizik & Videyo",
    "ja": "音楽とビデオ",
    "nl": "Muziek & Video's",
    "pl": "Muzyka & Wideo",
    "tr": "Müzik & Videolar"
  },
  "My Lineup": {
    "es": "Mi alineación",
    "fr": "composition d'équipe",
    "pt": "O meu alinhamento",
    "de": "Meine Formation",
    "ru": "Мой состав",
    "hi": "मेरा लाइनअप",
    "ar": "تشكيلتي",
    "zh-CN": "我的首发阵容",
    "sw": "Mpangilio Wangu",
    "ko": "내 라인업",
    "vi": "Danh Sách Đội Hình Của Tôi",
    "tl": "Ang Aking Lineup",
    "ht": "Alyenman Mwen",
    "ja": "私のラインアップ",
    "nl": "Mijn opstelling",
    "pl": "Moja Jedenastka",
    "tr": "Benim Kadrolarım"
  },
  "Negative": {
    "es": "Negativo",
    "fr": "Négatif",
    "pt": "Negativos:",
    "de": "Negativ",
    "it": "Negativo",
    "ru": "Отрицательный",
    "hi": "नकारात्मक",
    "ar": "سلبي",
    "zh-CN": "负面\n消极\n负面的",
    "sw": "Hasi",
    "ko": "부정적인",
    "vi": "Tiêu cực",
    "tl": "Negatibo",
    "ht": "Negatif",
    "ja": "否定的、ネガティブ",
    "nl": "Negatief",
    "pl": "Negatywny",
    "tr": "Olumsuz"
  },
  "News": {
    "es": "Noticias",
    "fr": "Actualités ",
    "pt": "Notícias",
    "it": "Notizie",
    "ru": "Новости",
    "hi": "समाचार",
    "ar": "أخبار",
    "zh-CN": "新闻",
    "sw": "Habari",
    "ko": "소식",
    "vi": "Tin tức",
    "tl": "Balita",
    "ht": "Nouvèl",
    "ja": "ニュース",
    "nl": "Nieuws",
    "pl": "Wiadomości",
    "tr": "Haber"
  },
  "No bookmarks yet": {
    "es": "Sin favoritos aún.",
    "fr": "Aucun favoris pour l'instant.",
    "pt": "Sem favoritos",
    "de": "Sie haben noch keine Lesezeichen.",
    "it": "Nessun segnalibro ancora",
    "ru": "У вас еще нет закладок.",
    "hi": "कोई पसंदीदा नहीं",
    "ar": "لا توجد علامات مرجعية حتى الآن",
    "zh-CN": "暂无书签",
    "sw": "Hakuna alama za ukurasa bado",
    "ko": "아직 북마크가 없습니다",
    "vi": "Chưa có dấu trang nào",
    "tl": "Walang bookmark pa",
    "ht": "Pa gen okenn mak jeneralman ankò",
    "ja": "ブックマークはまだありません",
    "nl": "Nog geen bladwijzers",
    "pl": "Brak zakładek",
    "tr": "Henüz yer imi yok"
  },
  "No books match your search.": {
    "es": "Ningún libro coincide con tu búsqueda.",
    "fr": "Aucun livre ne correspond à votre recherche.",
    "pt": "Nenhum livro corresponde à sua pesquisa.",
    "de": "Keine Bücher entsprechen Ihrer Suche.",
    "it": "Nessun libro corrisponde alla tua ricerca.",
    "ru": "По вашему запросу не найдено книг.",
    "hi": "कोई भी किताब आपकी खोज से मेल नहीं खाती।",
    "ar": "لا توجد كتب تطابق بحثك.",
    "zh-CN": "没有书籍与您的搜索相匹配。",
    "sw": "Hakuna kitabu kinachofanana na utaftaji wako.",
    "ko": "검색 결과와 일치하는 책이 없습니다.",
    "vi": "Không có sách nào phù hợp với tìm kiếm của bạn.",
    "tl": "Walang mga libro na tumutugma sa iyong paghahanap.",
    "ht": "Pa gen liv ki matche ak rechèch ou.",
    "ja": "検索に一致する本がありません。",
    "nl": "Geen boeken komen overeen met uw zoekopdracht.",
    "pl": "Żadne książki nie pasują do Twojego wyszukiwania.",
    "tr": "Arama kriterlerinize uygun kitap bulunmamaktadır."
  },
  "No entries found for": {
    "es": "No se han encontrado entradas",
    "fr": "Aucun entrée trouvée",
    "pt": "Não foram encontradas entradas",
    "de": "Keine Einträge gefunden",
    "it": "Nessuna voce trovata per",
    "ru": "Записи не найдены",
    "hi": "कोई प्रविष्टि नहीं मिली",
    "ar": "لم يتم العثور على أي إدخالات",
    "zh-CN": "未找到任何条目",
    "sw": "Hakuna maingizo iliyopatikana kwa",
    "ko": "항목을 찾을 수 없습니다",
    "vi": "Không tìm thấy mục nào",
    "tl": "Walang nahanap na entrada para sa",
    "ht": "Nou pa jwenn okenn antri",
    "ja": "エントリーが見つかりません",
    "nl": "Geen ingangen gevonden voor",
    "pl": "Brak wpisów dla",
    "tr": "Girdi bulunamadı"
  },
  "No entries found.": {
    "es": "No se encontraron entradas.",
    "fr": "Aucun témoignage trouvé.",
    "pt": "Não foram encontradas entradas.",
    "de": "Keine Einträge gefunden.",
    "it": "Nessuna voce trovata.",
    "ru": "Записей не найдено.",
    "hi": "कोई प्रविष्टि नहीं मिली",
    "ar": "لم يتم العثور على أي إدخالات.",
    "zh-CN": "未找到任何条目。",
    "sw": "Hakuna viingilio vilivyopatikana.",
    "ko": "항목을 찾을 수 없습니다.",
    "vi": "Không tìm thấy bất kỳ mục nào.",
    "tl": "Walang nahanap na mga entry.",
    "ht": "Yo pa jwenn anyen.",
    "ja": "エントリーが見つかりません。",
    "nl": "Geen vermeldingen gevonden.",
    "pl": "Nie znaleziono żadnych wpisów.",
    "tr": "Hiçbir giriş bulunamadı."
  },
  "No one found for": {
    "es": "No se ha encontrado a nadie para",
    "fr": "Personne n'a été trouvé pour",
    "pt": "Ninguém encontrado para",
    "de": "Niemand gefunden für",
    "it": "Nessuno trovato per",
    "ru": "По запросу ничего не найдено",
    "hi": "के लिए कोई नहीं मिला",
    "ar": "لم يُعثَر على أحد",
    "zh-CN": "未找到任何人",
    "sw": "Hakuna aliyekufa",
    "ko": "찾을 수 없는 사람이 없습니다",
    "vi": "Không tìm thấy ai",
    "tl": "Walang nahanap para sa",
    "ht": "Pa gen moun pou",
    "ja": "見つかりませんでした",
    "nl": "Er is niemand gevonden voor",
    "pl": "Nikt nie znaleziony dla",
    "tr": "Hiçbiri bulunamadı"
  },
  "No precepts found for your search.": {
    "es": "No se encontraron preceptos para tu búsqueda.",
    "fr": "Aucun précepte trouvé pour votre recherche.",
    "pt": "Nenhum preceito encontrado para a sua pesquisa.",
    "de": "Keine Regeln für Ihre Suche gefunden.",
    "it": "Nessun precetto trovato per la tua ricerca.",
    "ru": "Заповедей для поиска не найдено.",
    "hi": "आपकी खोज के लिए कोई उपदेश नहीं मिला।",
    "ar": "لم يتم العثور على أي قواعد لبحثك.",
    "zh-CN": "未找到您搜索的规则。",
    "sw": "Hakuna maagizo yaliyopatikana kwa ajili ya utaftaji wako.",
    "ko": "검색한 내용에 대한 교훈이 없습니다.",
    "vi": "Không tìm thấy giáo lệnh nào cho tìm kiếm của bạn.",
    "tl": "Walang nahanap na mga aral para sa iyong paghahanap.",
    "ht": "Pa gen prekèp ki jwenn pou rechèch ou a.",
    "ja": "あなたの検索に対する教えは見つかりませんでした。",
    "nl": "Geen voorzegels gevonden voor uw zoekopdracht.",
    "pl": "Nie znaleziono żadnych zasad dla Twojego wyszukiwania.",
    "tr": "Aradığınız için hiçbir ön öğreti bulunamadı."
  },
  "No results. Try a Bible reference, a Hebrew or Greek word, or a precept like \"Sabbath\".": {
    "es": "Sin resultados. Prueba una referencia bíblica, una palabra hebrea o griega, o un precepto como \"sábado\".",
    "fr": "Aucun résultat. Essayez une référence biblique, un mot hébreu ou grec, ou un précepte comme « Sabbat ».",
    "pt": "Sem resultados. Experimente uma referência bíblica, uma palavra hebraica ou grega ou um preceito como \"sábado\".",
    "de": "Keine Ergebnisse. Versuchen Sie es mit einer Bibelstelle, einem hebräischen oder griechischen Wort oder einem Gebot wie \"Sabbat\".",
    "it": "Nessun risultato. Prova con un riferimento biblico, una parola ebraica o greca, o un precetto come \"Sabato\".",
    "ru": "Нет результатов. Попробуйте ссылку на Библию, еврейское или греческое слово или заповедь типа «Суббота».",
    "hi": "कोई परिणाम नहीं। बाइबल संदर्भ, एक इब्रानी या यूनानी शब्द, या \"सब्त\" जैसे उपदेश का प्रयास करें।",
    "ar": "I understand you're giving me instructions for how to use a search or lookup tool, but I'm ready to translate text from English to Arabic for you. \n\nPlease provide the English text you'd like me to translate, and I'll convert it to natural, modern Arabic while preserving proper nouns and Bible references as specified.",
    "zh-CN": "没有结果。请尝试圣经引文、希伯来语或希腊语单词，或者\"安息日\"这样的诫命。",
    "sw": "Hakuna matokeo. Jaribu kumbukumbu ya Biblia, neno la Kiebraida au Kigiriki, au kanuni kama vile \"Sabato\".",
    "ko": "결과가 없습니다. 성경 구절, 히브리어 또는 그리스어 단어, 또는 \"안식일\"과 같은 교훈을 시도해보세요.",
    "vi": "Không có kết quả. Hãy thử một tài liệu tham khảo Kinh thánh, một từ tiếng Hebrew hoặc tiếng Hy Lạp, hoặc một giáo lý như \"Sabbath\".",
    "tl": "Walang resulta. Subukan ang isang sanggunian sa Biblia, isang Hebrew o Greek na salita, o isang prinsipyo tulad ng \"Sabbath\".",
    "ht": "Poko rezilta. Eseye yon referans Bib, yon mo Ebre oswa Grek, oswa yon prensip tankou \"Sabat\".",
    "ja": "No results. Try a Bible reference, a Hebrew or Greek word, or a precept like \"Sabbath\".\n\n結果がありません。聖書の参照、ヘブライ語またはギリシャ語の単語、または「安息日」のような原則を試してください。",
    "nl": "Geen resultaten. Probeer een Bijbelverwijzing, een Hebreeuws of Grieks woord, of een voorschrift als \"Sabbat\".",
    "pl": "Brak wyników. Spróbuj odwołania biblijnego, słowa hebrajskiego lub greckiego, albo zasady takiej jak \"Szabat\".",
    "tr": "Sonuç yok. Bir Kutsal Kitap ayetini, İbranice veya Yunanca bir sözcüğü veya \"Shabbat\" gibi bir ilkeyi deneyin."
  },
  "No rooms here yet": {
    "es": "Todavía no hay habitaciones",
    "fr": "Aucune chambre ici pour le moment",
    "pt": "Ainda não há quartos aqui",
    "de": "Noch keine Zimmer hier",
    "it": "Nessuna stanza qui ancora",
    "ru": "Здесь пока нет комнат",
    "hi": "यहाँ अभी तक कोई कमरा नहीं है",
    "ar": "لا توجد غرف هنا بعد",
    "zh-CN": "这里还没有房间",
    "sw": "Hakuna vyumba hapa bado",
    "ko": "여기는 아직 방이 없습니다.",
    "vi": "Chưa có phòng nào ở đây",
    "tl": "Walang mga kwarto dito pa",
    "ht": "Pa gen chanm isit la ankò",
    "ja": "ここにはまだ部屋がありません",
    "nl": "Hier zijn nog geen kamers",
    "pl": "Tutaj jeszcze nie ma pokojów",
    "tr": "Burada henüz oda yok."
  },
  "Notifications": {
    "es": "Notificaciones",
    "pt": "Notificações",
    "de": "Benachrichtigungen",
    "it": "Notifiche",
    "ru": "Уведомления",
    "hi": "नोटिफ़िकेशन",
    "ar": "إشعارات",
    "zh-CN": "通知",
    "sw": "Arifa",
    "ko": "알림",
    "vi": "Thông báo",
    "tl": "Mga Notipikasyon",
    "ht": "Notifikasyon",
    "ja": "通知",
    "nl": "Meldingen",
    "pl": "Powiadomienia",
    "tr": "Bildirimler"
  },
  "Notify me on holidays": {
    "es": "Notificarme en días festivos",
    "fr": "Me prévenir les jours fériés",
    "pt": "Notificar-me nos feriados",
    "de": "Benachrichtigen Sie mich an Feiertagen",
    "it": "Avvisami durante le festività",
    "ru": "Уведомлять меня о праздниках",
    "hi": "छुट्टियों पर मुझे सूचित करें",
    "ar": "أخبرني في الأعياد",
    "zh-CN": "在假日期间通知我",
    "sw": "Nijulishe wakati wa likizo",
    "ko": "휴일에 알림을 받으시겠습니까?",
    "vi": "Thông báo cho tôi vào những ngày lễ",
    "tl": "Ipabigay-alam sa akin sa mga pista",
    "ht": "Notifye m sou jou fèt yo",
    "ja": "休日に通知してください",
    "pl": "Powiadom mnie w dni świąteczne",
    "tr": "Bana tatil günlerinde haber ver."
  },
  "Now Featuring · Heritage Stage": {
    "es": "Ahora con · Etapa Heritage",
    "fr": "Désormais en vedette · Heritage Stage",
    "pt": "Now Featuring · Palco Heritage",
    "de": "Jetzt mit · Heritage-Abschnitt",
    "it": "Ora in Evidenza · Palco dell'Eredità",
    "ru": "Теперь с · Heritage Stage",
    "hi": "अब विशेषता · विरासत स्टेज",
    "ar": "الآن يعرض · مسرح التراث",
    "zh-CN": "现在特别呈现·传承舞台",
    "sw": "Sasa Ina Jukumu · Heritage Stage",
    "ko": "지금 공개 중 · 유산 무대",
    "vi": "Hiện Đang Giới Thiệu · Sân Khấu Di Sản",
    "tl": "Ngayon ay May Kasamang · Heritage Stage",
    "ht": "Kounye a Prezante · Estrad Eredite",
    "ja": "現在上演中・ヘリテージ・ステージ",
    "nl": "Nu te zien · Heritage Stage",
    "pl": "Teraz Prezentujemy · Scena Dziedzictwa",
    "tr": "Şimdi Sunulan · Miras Sahne"
  },
  "Open": {
    "es": "Abrir",
    "fr": "Ouvert",
    "pt": "Transparente",
    "de": "Öffnen",
    "it": "Apri",
    "ru": "Открыть",
    "hi": "खोलें",
    "zh-CN": "打开",
    "sw": "Fungua ",
    "ko": "열다/열려있다",
    "vi": "Mở",
    "tl": "Bukas",
    "ht": "Ouvri",
    "ja": "開く",
    "nl": "Opengesteld, Geopend",
    "pl": "Otwórz",
    "tr": "Aç"
  },
  "Open Live Newsroom": {
    "es": "Abrir sala de prensa en directo",
    "fr": "Ouvrir la salle de presse en direct",
    "pt": "Abrir Sala de Imprensa ao V",
    "de": "Live-Newsroom öffnen",
    "it": "Apri Centro Notizie in Diretta",
    "ru": "Открыть Live Newsroom",
    "hi": "लाइव न्यूज़रूम खोलें",
    "ar": "فتح غرفة الأخبار المباشرة",
    "zh-CN": "打开直播新闻编辑室",
    "sw": "Fungua Chumba cha Habari cha Moja kwa Moja",
    "ko": "열린 실시간 뉴스룸",
    "vi": "Mở Phòng Tin tức Trực tiếp",
    "tl": "Buksan ang Live Newsroom",
    "ht": "Ouvri Sal Nouvèl Dirèk",
    "ja": "ライブニュースルームを開く",
    "nl": "Open Live Nieuwsruimte",
    "pl": "Otwórz Redakcję na Żywo",
    "tr": "Canlı Haber Merkezi'ni Aç"
  },
  "Open chapter": {
    "es": "Abrir capítulo",
    "fr": "Ouvrir le chapitre",
    "pt": "Abrir capítulo",
    "de": "Kapitel öffnen",
    "it": "Capitolo iniziale",
    "ru": "Открыть главу",
    "hi": "अध्याय फ़ाइल खोलें",
    "ar": "فصل مفتوح",
    "zh-CN": "打开章节",
    "sw": "Fungua sura",
    "ko": "열린 장",
    "vi": "Mở chương",
    "tl": "Bukas na kabanata",
    "ht": "Ouvri chapit",
    "ja": "開く章",
    "nl": "Open Hoofdstuk",
    "pl": "Otwarty rozdział",
    "tr": "Açılış bölümü"
  },
  "Password": {
    "es": "Contraseña",
    "fr": "Mot de passe",
    "pt": "Senha",
    "de": "Passwort",
    "it": "Contraseña",
    "ru": "Пароль",
    "hi": "पासवर्ड",
    "ar": "كلمة المرور",
    "zh-CN": "密码",
    "sw": "Neno la siri",
    "vi": "I don't see any text to translate. Could you please provide the English text you'd like me to translate into Vietnamese?",
    "ht": "Modpas",
    "ja": "パスワード",
    "nl": "Wachtwoord",
    "tr": "Şifre"
  },
  "Pause devotional": {
    "es": "Pausar devocional",
    "fr": "Pause dévotionnelle",
    "pt": "Pausar devocional",
    "de": "Andacht pausieren",
    "it": "Pausa devozionale",
    "ru": "Пауза в преданном служении",
    "hi": "भक्ति को रोकें",
    "ar": "توقف تأملي",
    "zh-CN": "暂停灵修",
    "sw": "Kusimamisha ibada",
    "ko": "멈춤 경건의 시간",
    "vi": "Tạm dừng tư thiêm",
    "tl": "Pagtigil na Devoysonal",
    "ht": "Pause devosyonal",
    "ja": "休止の黙想",
    "nl": "Pauze-andachtsmoment",
    "pl": "Chwila na modlitwę",
    "tr": "Dinlenme andı"
  },
  "People who walk with you in the Word.": {
    "es": "Personas que caminan contigo en la Palabra.",
    "fr": "Les gens qui marchent avec vous dans la Parole.",
    "pt": "Pessoas que andam com você na Palavra.",
    "de": "Menschen, die mit dir im Wort wandeln.",
    "it": "Persone che camminano con te nella Parola.",
    "ru": "Люди, которые ходят с вами в Слове.",
    "hi": "जो लोग वचन में आपके साथ चलते हैं।",
    "ar": "الناس الذين يسيرون معك في الكلمة.",
    "zh-CN": "与你一起行走在圣言中的人。",
    "sw": "Watu wanaotembea nawe katika Neno.",
    "ko": "말씀 안에서 당신과 함께 걷는 사람들.",
    "vi": "Những người cùng bạn bước đi trong Lời.",
    "tl": "Mga taong naglalakad kasama mo sa Salita.",
    "ht": "Moun ki mache avèk ou nan Pawòl la.",
    "ja": "みことばの中であなたと一緒に歩む人たち。",
    "nl": "Mensen die met je in het Woord wandelen.",
    "pl": "Ludzie, którzy wędrują z tobą w Słowie.",
    "tr": "Seninle Tanrı'nın Sözü'nde yürüyen insanlar."
  },
  "Permanently remove your account, bookmarks, prayers, room memberships and messages. This cannot be undone.": {
    "es": "Elimina permanentemente tu cuenta, marcadores, oraciones, suscripciones a salas y mensajes. Esto no se puede deshacer.",
    "fr": "Supprimez définitivement votre compte, vos favoris, vos prières, vos abonnements et vos messages. Cela ne peut pas être annulé.",
    "pt": "Remova permanentemente sua conta, favoritos, orações, assinaturas de quartos e mensagens. Isso não pode ser desfeito.",
    "de": "Dein Konto, deine Lesezeichen, Gebete, Raummitgliedschaften und Nachrichten dauerhaft entfernen. Dies kann nicht rückgängig gemacht werden.",
    "it": "Rimuovi permanentemente il tuo account, i segnalibri, le preghiere, le iscrizioni alle stanze e i messaggi. Questa azione non può essere annullata.",
    "ru": "Удалить аккаунт, закладки, молитвы, членство в комнате и сообщения. Это действие нельзя отменить.",
    "hi": "अपना अकाउंट, बुकमार्क, प्रार्थना, रूम मेंबरशिप और मैसेज हमेशा के लिए हटा दें। इसे पूर्ववत नहीं किया जा सकता।",
    "ar": "حذف حسابك والإشارات المرجعية والصلوات وعضويات الغرف والرسائل بشكل دائم. لا يمكن التراجع عن هذا.",
    "zh-CN": "永久删除您的账户、书签、祷告、房间成员资格和消息。此操作无法撤销。",
    "sw": "Ondoa kabisa akaunti yako, alamisho, maombi, uanachama wa chumba na ujumbe. Hii haiwezi kutenduliwa.",
    "ko": "계정, 북마크, 기도, 방 멤버십 및 메시지를 영구적으로 삭제합니다. 이 작업은 취소할 수 없습니다.",
    "vi": "Xóa vĩnh viễn tài khoản, dấu trang, lời cầu nguyện, thành viên phòng và tin nhắn của bạn. Hành động này không thể hoàn tác.",
    "tl": "Permanenteng tanggalin ang iyong account, mga bookmark, mga panalangin, membership sa mga kuwarto at mga mensahe. Hindi na ito mababawi.",
    "ht": "Retire definitifman kont ou a, markedaj ou, priyè ou, manm chanm ou ak mesaj ou. Sa pa kapab defè.",
    "ja": "アカウント、ブックマーク、祈り、ルームメンバーシップ、メッセージを永久に削除します。この操作は元に戻すことはできません。",
    "nl": "Verwijder uw account, bladwijzers, gebeden, ruimtelidmaatschappen en berichten permanent. Dit kan niet ongedaan worden gemaakt.",
    "pl": "Trwale usunąć konto, zakładki, modlitwy, członkostwa w pokojach i wiadomości. Tej czynności nie można cofnąć.",
    "tr": "Hesabınızı, yer imlerinizi, dualarınızı, oda üyeliklerinizi ve mesajlarınızı kalıcı olarak silin. Bu işlem geri alınamaz."
  },
  "Pick the color theme for the whole app. Currently using:": {
    "es": "Elija el tema de color para toda la aplicación. Actualmente utilizando:",
    "fr": "Choisissez le thème de couleur pour l'ensemble de l'application. Actuellement en utilisant :",
    "pt": "Escolha o tema de cores para toda a aplicação. Atualmente a usar:",
    "de": "Wählen Sie das Farbschema für die gesamte App. Derzeit verwenden Sie:",
    "it": "Scegli il tema di colore per l'intera app. Attualmente in uso:",
    "ru": "Выберите цветовую тему для всего приложения. В настоящее время используется:",
    "hi": "पूरे ऐप के लिए रंग थीम चुनें। फ़िलहाल इसका इस्तेमाल कर रहे हैं:",
    "ar": "أختر مخطط الألوان للتطبيق بالكامل. حالياً يستخدم:",
    "zh-CN": "我无法完成这个请求。您提供的文本不包含需要翻译的内容——它只是一个不完整的指示,说\"目前正在使用:\",但没有列出任何颜色或主题信息。\n\n如果您想让我翻译关于应用颜色主题的文本,请提供完整的内容,包括具体的颜色名称、主题选项或相关描述。",
    "sw": "Chagua mandhari ya rangi ya programu nzima. Kwa sasa unatumia:",
    "ko": "앱 전체의 색상 테마를 선택하세요. 현재 사용 중:",
    "vi": "Tôi xin lỗi, nhưng tôi không thấy nội dung cần dịch trong thông điệp của bạn. Bạn có vẻ đang yêu cầu tôi chọn một chủ đề màu sắc cho một ứng dụng, nhưng đoạn văn dở dang ở \"Currently using:\" \n\nVui lòng cung cấp danh sách đầy đủ các màu sắc hiện tại mà bạn muốn tôi dịch, và tôi sẽ sẵn sàng giúp bạn.",
    "tl": "Pumili ng kulay na tema para sa buong app. Kasalukuyang gumagamit ng:",
    "ht": "Chwazi tèm koulè pou tout aplikasyon an. Aktyèlman ap itilize:",
    "ja": "アプリ全体のカラーテーマを選んでください。現在使用中：",
    "nl": "Kies het kleurthema voor de hele app. Momenteel gebruikt:",
    "pl": "Wybierz schemat kolorów dla całej aplikacji. Obecnie używany:",
    "tr": "Uygulama için renk temasını seçin. Şu anda kullanılan:"
  },
  "Play 60-sec devotional": {
    "es": "Juega al devocional de 60 segundos",
    "fr": "Jouez à la dévotion de 60 secondes",
    "pt": "Reproduzir devocional de 60 segundos",
    "de": "Spiele eine 60-Sekunden-Andacht",
    "ru": "Играйте в 60-секундный преданный",
    "hi": "60 सेकंड की भक्ति - भावना से खेलें"
  },
  "Play all": {
    "es": "Reproducir todo",
    "fr": "Repasser tout",
    "pt": "Reproduzir tudo",
    "de": "Alle abspielen",
    "it": "Riproduci tutto",
    "ru": "Играть все",
    "hi": "सभी को प्ले करें",
    "ar": "شغّل الكل",
    "zh-CN": "播放全部",
    "sw": "Cheza yote",
    "ko": "모두 재생",
    "vi": "Phát tất cả",
    "tl": "Laruin lahat",
    "ht": "Jwe tout",
    "ja": "すべて再生",
    "nl": "Alles afspelen",
    "pl": "Odtwórz wszystko"
  },
  "Positive": {
    "es": "Positivo",
    "fr": "Positif",
    "pt": "Positivo",
    "de": "Positiv",
    "it": "Positivo",
    "ru": "Положительный",
    "hi": "सकारात्मक",
    "ar": "إيجابي",
    "zh-CN": "积极",
    "sw": "Chanya",
    "ko": "긍정적",
    "vi": "Tích cực",
    "tl": "Positibo",
    "ht": "Pozitif",
    "ja": "ポジティブ",
    "nl": "Positief",
    "pl": "Pozytywny",
    "tr": "Olumlu"
  },
  "Preview today's digest": {
    "es": "Vista previa del resumen de hoy",
    "fr": "Prévisualiser le résumé d'aujourd' hui",
    "pt": "Pré-visualizar o resumo de hoje",
    "de": "Vorschau der heutigen Zusammenfassung",
    "it": "Anteprima del digest di oggi",
    "ru": "Предпросмотр сегодняшнего дайджеста",
    "hi": "आज के डाइजेस्ट का पूर्वावलोकन करें",
    "ar": "معاينة ملخص اليوم",
    "zh-CN": "今天摘要预览",
    "sw": "Hakiki umeng 'enyaji wa leo",
    "ko": "오늘의 요약본을 미리보기",
    "tl": "Tingnan ang araw na ito ng balita",
    "ht": "Previzyon jòdi pou rezime a",
    "ja": "本日のダイジェストをプレビューする",
    "nl": "Bekijk vandaag's samenvatting",
    "pl": "Podgląd dzisiejszego streszczenia",
    "tr": "Bugünün özeti"
  },
  "Private (passcode-protected)": {
    "es": "Privado (protegido con contraseña)",
    "fr": "Privé (protégé par un mot de passe)",
    "pt": "Privado (protegido por senha)",
    "de": "Privat (passcodegeschützt)",
    "ru": "Частный (защищенный паролем)",
    "hi": "निजी (पासकोड - सुरक्षित)",
    "zh-CN": "私密（密码保护）",
    "sw": "Binafsi (msimbo wa siri unaolindwa)",
    "vi": "Riêng tư (được bảo vệ bằng mật khẩu)",
    "ht": "Prive (pwoteje pa kod sekre)",
    "ja": "非公開（パスコード保護）",
    "nl": "Privé (wachtwoordbeveiliged)",
    "pl": "Prywatne (chronione hasłem)",
    "tr": "Özel (şifre korumalı)"
  },
  "Public-domain entries from Easton's Bible Dictionary. Search a word, a name, or a place.": {
    "es": "Entradas de dominio público del Diccionario Bíblico de Easton. Busca una palabra, un nombre o un lugar.",
    "fr": "Entrées du domaine public du dictionnaire biblique d'Easton. Recherchez un mot, un nom ou un lieu.",
    "pt": "Entradas de domínio público do Dicionário Bíblico de Easton. Pesquise uma palavra, um nome ou um lugar.",
    "de": "Public-Domain-Einträge aus Eastons Bible Dictionary. Suche nach einem Wort, einem Namen oder einem Ort.",
    "it": "Voci di dominio pubblico dal Dizionario Biblico di Easton. Cerca una parola, un nome o un luogo.",
    "ru": "Публичные записи из Библейского словаря Истона. Поиск по слову, названию или месту.",
    "hi": "ईस्टन के बाइबल शब्दकोश से सार्वजनिक डोमेन प्रविष्टियां। कोई शब्द, नाम या जगह खोजें।",
    "ar": "إدخالات من قاموس إيستون للكتاب المقدس - الملك العام. ابحث عن كلمة أو اسم أو مكان.",
    "zh-CN": "Easton圣经词典中的公共领域词条。搜索一个词、一个名字或一个地方。",
    "sw": "Machapisho ya ziada ya Kamusi ya Bibilia ya Easton. Tafuta neno, jina, au mahali.",
    "ko": "Easton 성경 사전의 공개 도메인 항목입니다. 단어, 인명, 또는 지명을 검색하세요.",
    "vi": "Các mục từ trong miền công cộng từ Từ điển Kinh Thánh Easton. Tìm kiếm một từ, một tên, hoặc một địa điểm.",
    "tl": "Mga entry mula sa Easton's Bible Dictionary na nasa public domain. Maghanap ng isang salita, pangalan, o lugar.",
    "ht": "Antre nan domèn piblik nan Diksyonè Bib Easton. Chèche yon mo, yon non, oswa yon kote.",
    "ja": "パブリックドメインのイーストン聖書辞書の項目。単語、名前、または場所を検索してください。",
    "nl": "Openbare-domein-artikelen uit Eaton's Bijbel Woordenboek. Zoek een woord, een naam of een plaats.",
    "pl": "Wpisy z zakresu darmenikownika biblijnego Eastona. Wyszukaj słowo, imię lub miejsce.",
    "tr": "Easton'un Bible Sözlüğünden kamu malı girdileri. Bir kelime, ad veya yer arayın."
  },
  "Read the Bible aloud in ten global languages, follow along with cartoon stories crafted for kids, and bookmark the verses you carry through the day.": {
    "es": "Lea la Biblia en voz alta en diez idiomas globales, siga las historias de dibujos animados diseñadas para niños y marque los versículos que lleva a lo largo del día.",
    "fr": "Lisez la Bible à haute voix dans dix langues du monde, suivez des histoires de dessins animés conçues pour les enfants et marquez les versets que vous portez tout au long de la journée.",
    "pt": "Leia a Bíblia em voz alta em dez idiomas globais, acompanhe histórias de desenhos animados criadas para crianças e marque os versículos que você carrega durante o dia.",
    "de": "Lesen Sie die Bibel in zehn globalen Sprachen vor, folgen Sie Cartoon-Geschichten für Kinder und markieren Sie die Verse, die Sie durch den Tag tragen.",
    "it": "Leggi la Bibbia ad alta voce in dieci lingue globali, segui storie a fumetti create per i bambini, e metti nei segnalibri i versetti che porti con te durante il giorno.",
    "ru": "Читайте Библию вслух на десяти языках мира, следите за мультипликационными историями, созданными для детей, и добавляйте в закладки стихи, которые вы несете в течение дня.",
    "hi": "दस वैश्विक भाषाओं में बाइबिल को जोर से पढ़ें, बच्चों के लिए तैयार की गई कार्टून कहानियों का पालन करें, और उन छंदों को बुकमार्क करें जिन्हें आप पूरे दिन ले जाते हैं।",
    "ar": "اقرأ الكتاب المقدس بصوت عالٍ في عشر لغات عالمية، وتابع القصص الكرتونية المصممة للأطفال، وضع علامات مرجعية على الآيات التي تحملها معك طوال اليوم.",
    "zh-CN": "用十种全球语言大声朗读圣经,跟随为孩子们精心制作的卡通故事,并为您全天携带的经文添加书签。",
    "sw": "Soma Bibilia kwa sauti katika lugha kumi za ulimwengu, fuata hadithi za picha zilizoundwa kwa watoto, na weka alama ya amanzi ayat ambazo unazibeba kila siku.",
    "ko": "성경을 10가지 글로벌 언어로 큰 소리로 읽고, 아이들을 위해 만들어진 만화 이야기를 따라가며, 하루 종일 당신과 함께 가져가는 구절들을 북마크하세요.",
    "vi": "Đọc Kinh Thánh to tiếng to bằng mười ngôn ngữ trên toàn thế giới, theo dõi những câu chuyện hoạt hình được tạo ra cho trẻ em, và đánh dấu những câu Kinh Thánh bạn mang theo trong ngày.",
    "tl": "Basahin ang Bibliya nang malakas sa sampung pandaigdigang wika, sumunod kasama ang mga kuwento ng cartoon na ginawa para sa mga bata, at i-bookmark ang mga ayat na dala mo sa buong araw.",
    "ht": "Li Bib la a wo nan dis lang mondial, swiv avèk istwa desinen yo ki fèt pou timoun, epi fè bokmark vèse yo ou pote nan jounen ou.",
    "ja": "聖書を世界の10の言語で音声で読み、子どもたちのために作られた漫画のストーリーに従いながら読み進め、一日を通して心に留めておく聖句にしおりをつけましょう。",
    "nl": "Lees de Bijbel hardop in tien wereldtalen, volg verhalen mee die speciaal voor kinderen in cartoons zijn gemaakt, en bladwijzer de verzen die je door de dag meedraagt.",
    "pl": "Czytaj Biblię na głos w dziesięciu światowych językach, śledź historyjki z kreskówek stworzone dla dzieci i zaznaczaj wersety, które noszysz ze sobą przez cały dzień.",
    "tr": "Kutsal Kitabı on küresel dilde sesli oku, çocuklar için hazırlanmış karikatür hikayelerini takip et ve gün boyunca yanında taşıdığın ayetleri işaretle."
  },
  "Reference": {
    "es": "Referencia",
    "fr": "Référence",
    "pt": "Referência",
    "de": "Referenz",
    "ru": "документа",
    "hi": "मुझे फुटबॉल और क्रिकेट खेलना पसंद है",
    "ar": "مرجع",
    "zh-CN": "参考",
    "vi": "Tham chiếu",
    "tl": "Sanggunian",
    "ht": "Referans",
    "nl": "Referentie",
    "pl": "Odnosić się do, odwoływać się do, cytować, referencja, źródło"
  },
  "Reminders on": {
    "es": "Recordatorios activados",
    "fr": "Rappels sur",
    "pt": "Lembretes em",
    "de": "Erinnerungen an",
    "ru": "Напоминания на",
    "hi": "को रिमाइंडर",
    "ar": "تذكيرات مشغّلة",
    "zh-CN": "提醒已开启",
    "sw": "Kumbusho kwenye",
    "ko": "알림 켜짐",
    "vi": "Nhắc nhở bật",
    "ht": "Raple yo alimante",
    "ja": "I'm ready to help you translate from English to Japanese. Please go ahead and share the text you'd like me to translate.",
    "nl": "Herinneringen aan",
    "pl": "Przypomnienia włączone",
    "tr": "Hatırlatıcılar açık"
  },
  "Save the verses that move you and revisit them anytime.": {
    "es": "Guarda los versículos que te conmueven y revísalos en cualquier momento.",
    "fr": "Enregistrez les versets qui vous émeuvent et revisitez-les à tout moment.",
    "pt": "Salve os versículos que o movem e revise-os a qualquer momento.",
    "de": "Bewahre die Verse auf, die dich bewegen, und besuche sie jederzeit wieder.",
    "it": "Salva i versetti che ti toccano il cuore e ritornaci sopra quando vuoi.",
    "ru": "Сохраняйте стихи, которые вас волнуют, и пересматривайте их в любое время.",
    "hi": "उन आयतों को सहेजें जो आपको हिलाती हैं और उन्हें किसी भी समय फिर से देखें।",
    "ar": "احفظ الآيات التي تلمس قلبك وعد إليها في أي وقت.",
    "zh-CN": "保存那些触动你心灵的经文，随时可以重新阅读。",
    "sw": "Hifadhi ayati zinazoukuathiri na urudi kwayo wakati wowote.",
    "ko": "마음을 감동시키는 구절들을 저장해두고 언제든지 다시 돌아보세요.",
    "vi": "Lưu lại những câu Kinh Thánh chạm động bạn và quay lại với chúng bất cứ lúc nào.",
    "tl": "Iligtas ang mga berso na tumatagos sa iyong puso at muling basahin anumang oras.",
    "ht": "Sove vè yo ki twouble ou yo e gade yo ankò nenpòt lè ou vle.",
    "ja": "あなたの心を動かす聖句を保存して、いつでも見直してください。",
    "nl": "Bewaar de verzen die je raken en bezoek ze op elk moment.",
    "pl": "Zapisuj wersety, które Cię poruszają, i wracaj do nich w każdej chwili.",
    "tr": "Seni etkileyen ayetleri kaydet ve istediğin zaman onlara geri dön."
  },
  "Saved Verses": {
    "es": "Versículos guardados",
    "fr": "Versets enregistrés",
    "pt": "Versículos salvos",
    "de": "Gespeicherte Verse",
    "it": "Versetti Salvati",
    "ru": "Сохраненные стихи",
    "hi": "सेव की गई आयतें",
    "ar": "الآيات المحفوظة",
    "zh-CN": "保存的经文",
    "sw": "Mistari Iliyohifadhiwa",
    "ko": "저장된 성구",
    "vi": "Những Câu Kinh Đã Lưu",
    "tl": "Nakatipid na mga Araw",
    "ht": "Vèsèt Sove",
    "ja": "保存されたみことば",
    "nl": "Opgeslagen Verzen",
    "pl": "Zapisane Wersety",
    "tr": "Kaydedilen Ayetler"
  },
  "Scripture": {
    "es": "Escritura",
    "fr": "L'écriture",
    "pt": "Livro sagrado",
    "de": "Heilige Schrift",
    "it": "Scrittura",
    "ru": "Священное Писание",
    "hi": "धर्मग्रन्थ",
    "ar": "الكتاب المقدس",
    "zh-CN": "经文",
    "sw": "Maandiko Matakatifu. ",
    "ko": "성경",
    "vi": "Kinh Thánh",
    "tl": "Kasulatan",
    "ht": "Ekriti",
    "ja": "聖書",
    "nl": "Schrift",
    "pl": "Pismo Święte",
    "tr": "Kutsal Yazılar"
  },
  "Search": {
    "es": "Buscar",
    "fr": "Rechercher",
    "pt": "Pesquisar",
    "de": "Suche",
    "it": "Ricerca",
    "ru": "Поиск",
    "hi": "खोज",
    "ar": "بحث",
    "zh-CN": "搜索",
    "sw": "Tafuta",
    "ko": "검색",
    "vi": "Tìm kiếm",
    "tl": "Maghanap",
    "ht": "Chèche",
    "ja": "検索",
    "nl": "Zoeken",
    "pl": "Szukaj",
    "tr": "Ara"
  },
  "Searching…": {
    "es": "Buscando…",
    "fr": "Recherche en cours…",
    "pt": "Pesquisando…",
    "de": "Suchen …",
    "ru": "Поиск…",
    "hi": "खोज कर रहा है... ",
    "ar": "I'm ready to help translate! Please go ahead and share the English text you'd like me to translate into Arabic.",
    "zh-CN": "搜索中…",
    "sw": "Inatafuta...",
    "ko": "검색 중…",
    "vi": "Đang tìm kiếm…",
    "tl": "Naghahanap…",
    "ht": "Mwen ap chèche...",
    "pl": "Szukanie…",
    "tr": "Aranıyor…"
  },
  "See plans ($5/mo or $29 lifetime)": {
    "es": "Ver planes ($ 5/mes o $ 29 de por vida)",
    "fr": "Voir les forfaits (5 $ / mois ou 29 $ à vie)",
    "pt": "Ver planos ($ 5/mês ou $ 29 vitalícios)",
    "de": "Siehe Pläne ($ 5/Monat oder $ 29 Lebensdauer)",
    "it": "Visualizza i piani ($5/mese o $29 a vita)",
    "ru": "Посмотреть планы ($ 5/мес. или $ 29 пожизненно)",
    "hi": "योजनाएँ देखें ($ 5/माह या $ 29 आजीवन)",
    "ar": "اطلع على الخطط (5 دولار/شهر أو 29 دولار مدى الحياة)",
    "zh-CN": "查看计划（每月 $5 或终身 $29）",
    "sw": "Tazama mipango ($5 kwa mwezi au $29 maisha yote)",
    "ko": "요금제 보기 ($월 5달러 또는 평생 $29)",
    "vi": "Xem kế hoạch ($5/tháng hoặc $29 trọn đời)",
    "tl": "Tingnan ang mga plano ($5/buwan o $29 pangmatagalan)",
    "ht": "Gade plan yo ($5/mwa oswa $29 tout lavi)",
    "ja": "プランを見る（月額$5またはライフタイム$29）",
    "nl": "Bekijk plannen ($5/maand of $29 eenmalig)",
    "pl": "Zobacz plany (5 USD/miesiąc lub 29 USD dożywotnio)",
    "tr": "Planları Görüntüle ($5/ay veya $29 ömür boyu)"
  },
  "Send reset link": {
    "es": "Enviar enlace para restablecer la contraseña",
    "fr": "Envoyer un lien de réinitialisation",
    "pt": "Enviar link de redefinição",
    "de": "Link zuschicken",
    "it": "Invia link di reimpostazione",
    "ru": "Отправить ссылку для сброса",
    "hi": "रीसेट लिंक भेजें",
    "ar": "أرسل رابط إعادة تعيين",
    "zh-CN": "发送重置链接",
    "sw": "Tuma kiungo cha kuanzisha upya",
    "ko": "재설정 링크 전송",
    "vi": "Gửi liên kết đặt lại mật khẩu",
    "tl": "Magpadala ng link sa pag-reset",
    "ht": "Voye lyen pou rekonekte",
    "ja": "パスワードをリセットするリンクを送信する",
    "nl": "Verstuur resetlink",
    "pl": "Wyślij link do zresetowania",
    "tr": "Sıfırlama bağlantısını gönder"
  },
  "Send test email": {
    "es": "Enviar correo electrónico de prueba",
    "fr": "Envoyer un e-mail de test",
    "pt": "Enviar E-Mail de teste",
    "de": "Test-E-Mail senden",
    "it": "Invia email di prova",
    "ru": "Отправить тестовое сообщение",
    "hi": "टेस्ट ईमेल भेजें",
    "zh-CN": "发送测试邮件",
    "sw": "Tuma barua pepe ya mtihani",
    "ko": "테스트 이메일 발송",
    "vi": "Gửi email thử nghiệm",
    "tl": "Magpadala ng email sa pagsubok",
    "ht": "Envwaye email tès",
    "nl": "Stuuur test-e-mail",
    "pl": "Wyślij testową wiadomość e-mail",
    "tr": "Test e-postası gönder"
  },
  "Sent": {
    "es": "Enviado",
    "fr": "Envoyé",
    "pt": "Enviado",
    "de": "Gesendet",
    "it": "Inviato",
    "ru": "Отправлено",
    "hi": "भेजी- डाक",
    "ar": "تم الإرسال",
    "zh-CN": "已发送",
    "sw": "Imetumwa",
    "ko": "보냈습니다.",
    "vi": "Đã gửi",
    "tl": "Ipinadala",
    "ja": "送信されました。",
    "tr": "I'm ready to help! Please provide the English text you'd like me to translate into Turkish."
  },
  "Short cartoons & picture-Bible favourites": {
    "es": "Dibujos animados cortos e imágenes favoritas de la Biblia",
    "fr": "Courts dessins animés et images - Favoris de la Bible",
    "pt": "Desenhos animados curtos e imagens - Favoritos da Bíblia",
    "de": "Kurze Cartoons & Bilder-Bibel-Favoriten",
    "it": "Cartoni animati brevi e preferiti della Bibbia illustrata",
    "ru": "Короткие мультфильмы и картинки - избранное из Библии",
    "hi": "छोटे कार्टून और पिक्चर - बाइबल के पसंदीदा",
    "ar": "رسوم متحركة قصيرة ومواد الكتاب المقدس المصورة المفضلة",
    "zh-CN": "短篇卡通和图画圣经最爱",
    "sw": "Karatasi fupi za picha & Hadithi za Bibilia za Kupendeza",
    "ko": "짧은 만화 & 그림 성경 인기작",
    "vi": "Phim hoạt hình ngắn và những yêu thích của Thánh Kinh hình ảnh",
    "tl": "Maikling cartoons at mga paboritong picture-Bible",
    "ht": "Ti fim desen ak favori Bib ak foto",
    "ja": "短いアニメ漫画と絵本聖書の人気作品",
    "nl": "Korte cartoons & favoriete Bijbelplaatjes",
    "pl": "Krótkie kreskówki i ulubione obrazkowe Biblie",
    "tr": "Kısa Çizgi Filmler ve Resimli İncil Favorileri"
  },
  "Shuffle": {
    "es": "Barajar",
    "fr": "Mélanger",
    "pt": "Aleatório",
    "de": "Mischen",
    "it": "Mescolare",
    "hi": "आवाज़ कम करें",
    "ar": "أخلط",
    "zh-CN": "洗牌",
    "sw": "Changanya",
    "ko": "섞다",
    "vi": "Xáo trộn",
    "tl": "Haluin",
    "ht": "Melanje",
    "ja": "シャッフル",
    "nl": "Schudden",
    "pl": "Przetasuj",
    "tr": "Karıştır"
  },
  "Sign In": {
    "es": "Registrate",
    "fr": "S’authentifier",
    "pt": "Iniciar sessão",
    "de": "Anmelden",
    "it": "Accedi",
    "ru": "Войти",
    "hi": "साइन इन करें",
    "ar": "دخول",
    "zh-CN": "登录",
    "sw": "Ingia",
    "ko": "로그인",
    "vi": "Đăng Nhập",
    "tl": "Magsimula",
    "ht": "Konekte",
    "ja": "サインイン",
    "nl": "Inloggen",
    "pl": "Zaloguj się",
    "tr": "Giriş Yap"
  },
  "Sign in": {
    "es": "Iniciar sesión",
    "fr": "Connecter",
    "pt": "Iniciar sessão",
    "de": "Anmelden",
    "it": "Accedi",
    "ru": "Зарегистрироваться",
    "hi": "साइन इन करें",
    "ar": "دخول",
    "zh-CN": "登录",
    "sw": "Ingia",
    "ko": "로그인",
    "vi": "Đăng nhập",
    "tl": "Magpasok",
    "ht": "Konekte",
    "ja": "サインイン",
    "nl": "Inloggen",
    "pl": "Zaloguj się",
    "tr": "Giriş Yap"
  },
  "Sign in to create a room": {
    "es": "Inicia sesión para crear una habitación",
    "fr": "Connectez-vous pour créer une chambre",
    "pt": "Inicie sessão para criar uma sala",
    "de": "Melden Sie sich an, um einen Raum zu erstellen",
    "it": "Accedi per creare una stanza",
    "ru": "Войдите, чтобы создать комнату",
    "hi": "कमरा बनाने के लिए साइन इन करें",
    "ar": "سجل الدخول لإنشاء غرفة",
    "zh-CN": "登录以创建房间",
    "sw": "Ingia ili kuunda chumba",
    "ko": "방에 입장하려면 로그인하세요",
    "vi": "Đăng nhập để tạo một phòng",
    "tl": "Mag-sign in upang lumikha ng kuwarto",
    "ht": "Konekte w pou w ka kreye yon chanm",
    "ja": "ルームを作成するにはサインインしてください",
    "nl": "Meld je aan om een kamer te maken",
    "pl": "Zaloguj się, aby utworzyć pokój",
    "tr": "Oda oluşturmak için oturum açın"
  },
  "Sign in to keep your favorites": {
    "es": "Inicia sesión para conservar tus favoritos",
    "fr": "Connectez-vous pour conserver vos favoris",
    "pt": "Inicie sessão para manter os seus favoritos",
    "de": "Melden Sie sich an, um Ihre Favoriten zu behalten",
    "it": "Accedi per salvare i tuoi preferiti",
    "ru": "Войдите, чтобы сохранить избранное",
    "hi": "अपने पसंदीदा बनाए रखने के लिए साइन इन करें",
    "ar": "سجل الدخول للاحتفاظ بمفضلاتك",
    "zh-CN": "登录以保存您的收藏",
    "sw": "Ingia ili udumishe vipendwa vyako",
    "ko": "즐겨찾기를 저장하려면 로그인하세요",
    "vi": "Đăng nhập để lưu lại mục yêu thích của bạn",
    "tl": "Magpasok upang mapanatili ang iyong mga paboritong",
    "ht": "Konekte pou ka sove favori ou yo",
    "ja": "お気に入りを保存するにはサインインしてください",
    "nl": "Meld je aan om je favorieten op te slaan",
    "pl": "Zaloguj się, aby zachować swoje ulubione",
    "tr": "Favorilerinizi kaydetmek için oturum açın"
  },
  "Sign in to save creators' videos for later and watch them back-to-back.": {
    "es": "Inicia sesión para guardar los vídeos de los creadores para más tarde y verlos consecutivamente.",
    "fr": "Connectez-vous pour enregistrer les vidéos des créateurs pour plus tard et les regarder l'une après l'autre.",
    "pt": "Inicie sessão para guardar os vídeos dos criadores para mais tarde e vê-los consecutivamente.",
    "de": "Melde dich an, um die Videos der Kreativen für später zu speichern und sie hintereinander anzusehen.",
    "it": "Accedi per salvare i video dei creator in seguito e guardarli uno dopo l'altro.",
    "ru": "Войдите, чтобы сохранить видео креаторов на потом и смотреть их в спину.",
    "hi": "बाद के लिए क्रिएटर्स के वीडियो सेव करने के लिए साइन इन करें और उन्हें एक - एक करके देखें.",
    "ar": "سجّل الدخول لحفظ فيديوهات المبدعين للمشاهدة لاحقاً ومتابعة مشاهدتها بدون توقف.",
    "zh-CN": "登录以保存创作者的视频供日后观看，并连续观看。",
    "sw": "Ingia ili uhifadhi video za wabunifu kwa ajili ya baadaye na uziangalie nyuma-kwa-nyuma.",
    "ko": "나중에 볼 수 있도록 크리에이터의 영상을 저장하고 연속으로 시청하려면 로그인하세요.",
    "vi": "Đăng nhập để lưu video của các nhà sáng tạo để xem lại sau và xem chúng liên tiếp.",
    "tl": "Mag-sign in upang makatipid ng mga video ng mga creator para sa ibang panahon at panoorin ang mga ito nang sunod-sunod.",
    "ht": "Konekte pou w ka sove videyo kreyatè yo pou apre epi gade yo youn apre lòt.",
    "ja": "クリエイターのビデオを後で見るために保存して、次々と見返すためにサインインしてください。",
    "nl": "Meld je aan om video's van makers later op te slaan en achter elkaar af te spelen.",
    "pl": "Zaloguj się, aby zapisywać filmy twórców na później i oglądać je jeden za drugim.",
    "tr": "Daha sonra izlemek için yapımcıların videolarını kaydetmek ve arka arkaya izlemek için oturum açın."
  },
  "Sign in to send friend requests and start a circle.": {
    "es": "Inicia sesión para enviar solicitudes de amistad y formar un círculo.",
    "fr": "Connectez-vous pour envoyer des demandes d'amis et créer un cercle.",
    "pt": "Inicie sessão para enviar pedidos de amizade e iniciar um círculo.",
    "de": "Melden Sie sich an, um Freundschaftsanfragen zu senden und einen Kreis zu starten.",
    "it": "Accedi per inviare richieste di amicizia e avviare un cerchio.",
    "ru": "Войдите, чтобы отправлять запросы на добавление в друзья и создать круг.",
    "hi": "मित्र अनुरोध भेजने और एक मंडली शुरू करने के लिए साइन इन करें।",
    "ar": "سجّل الدخول لإرسال طلبات الصداقة وابدأ دائرة.",
    "zh-CN": "登录以发送好友请求并开始建立圈子。",
    "sw": "Ingia ili utume maombi ya rafiki na uanzishe duara.",
    "ko": "친구 요청을 보내고 서클을 시작하려면 로그인하세요.",
    "vi": "Đăng nhập để gửi lời mời kết bạn và bắt đầu một vòng tròn.",
    "tl": "Mag-sign in upang magpadala ng friend requests at magsimula ng isang circle.",
    "ht": "Konekte pou ou ka voye demann zanmi ak fòme yon sèk.",
    "ja": "サインインしてフレンドリクエストを送信し、サークルを始めましょう。",
    "nl": "Meld u aan om vriendenverzoeken te verzenden en een cirkel te starten.",
    "pl": "Zaloguj się, aby wysyłać zaproszenia do przyjaciół i założyć grupę.",
    "tr": "Arkadaş istekleri göndermek ve bir çember başlatmak için oturum açın."
  },
  "Signed in as": {
    "es": "Conectado como",
    "fr": "Vous êtes déjà connecté",
    "pt": "﻿Registrado como",
    "de": "Angemeldet als",
    "it": "Accesso effettuato come",
    "ru": "Зарегистрировался как",
    "hi": "के रूप में साइन इन किया गया",
    "zh-CN": "已登录为",
    "sw": "Imeingia kama",
    "ko": "로그인됨",
    "vi": "Đã đăng nhập dưới dạng",
    "tl": "Naka-sign in bilang",
    "ht": "Konekte kòm",
    "ja": "ログインしました",
    "nl": "Aangemeld als",
    "pl": "Zalogowany jako",
    "tr": "Giriş yapıldı"
  },
  "Start Reading": {
    "es": "Comenzar a leer",
    "pt": "Iniciar a leitura",
    "de": "Jetzt lesen",
    "it": "Inizia a Leggere",
    "ru": "Начать читать",
    "hi": "पढ़ना शुरू करें",
    "ar": "ابدأ في القراءة",
    "zh-CN": "开始阅读",
    "sw": "Anza Kusoma",
    "ko": "읽기 시작하세요",
    "vi": "Bắt đầu đọc",
    "tl": "Magsimula ng Pagbabasa",
    "ht": "Komanse Lè w ap Li",
    "ja": "読み始めてください",
    "nl": "Begin met Lezen",
    "pl": "Zacznij Czytać",
    "tr": "Okumaya Başla"
  },
  "Strong's Concordance": {
    "es": "Concordancia de Strong",
    "fr": "de la concordance de Strong.",
    "pt": "Concordância de Strong",
    "de": "Strongs Konkordanz",
    "it": "Concordanza di Strong",
    "ru": "Согласие Стронга",
    "hi": "मज़बूत सामंजस्य",
    "ar": "قاموس سترونج",
    "zh-CN": "Strong's 圣经汇编",
    "sw": "Strong's Concordance\n\nKamusi ya Strong",
    "ko": "Strong's 성경 단어 사전",
    "vi": "Từ điển Tương ứng Strong",
    "tl": "Concordance ng Strong",
    "ht": "Konkordans Strong",
    "nl": "Strong's Concordantie",
    "pl": "Konkordancja Strong'a",
    "tr": "Strong'un Uyum Sözlüğü"
  },
  "Tap the \"Lineup\" button on any creator's video to start building a continuous watch list.": {
    "es": "Toca el botón \"Alineación\" en el video de cualquier creador para comenzar a crear una lista de reproducción continua.",
    "fr": "Appuyez sur le bouton « Liste » de la vidéo de n'importe quel créateur pour commencer à créer une liste de surveillance continue.",
    "pt": "Toque no botão \"Alinhamento\" no vídeo de qualquer criador para começar a criar uma lista de observação contínua.",
    "de": "Tippe auf die Schaltfläche „Aufstellung“ im Video eines/einer Kreativen, um eine fortlaufende Beobachtungsliste zu erstellen.",
    "it": "Tocca il pulsante \"Sequenza\" su qualsiasi video di un creatore per iniziare a creare una lista di visione continua.",
    "ru": "Нажмите кнопку «Состав» на любом видео креатора, чтобы начать создавать непрерывный список наблюдения.",
    "hi": "लगातार वॉच लिस्ट बनाना शुरू करने के लिए किसी भी क्रिएटर के वीडियो पर \"लाइनअप\" बटन पर टैप करें।",
    "ar": "اضغط على زر \"قائمة التشغيل\" على أي فيديو للمنشئ لبدء بناء قائمة مشاهدة مستمرة.",
    "zh-CN": "点击任何创作者视频上的\"播放列表\"按钮，开始构建连续观看列表。",
    "sw": "Bonyeza kitufe cha \"Orodha ya Video\" kwenye video ya mwenye wasifu wowote ili kuanza kujenga orodha ya kuangalia inayoendelea.",
    "ko": "모든 크리에이터의 동영상에서 \"라인업\" 버튼을 탭하여 연속 시청 목록을 만들기 시작하세요.",
    "vi": "Nhấn nút \"Danh sách phát\" trên bất kỳ video của người sáng tạo nào để bắt đầu xây dựng danh sách xem liên tục.",
    "tl": "I-tap ang \"Lineup\" button sa anumang video ng isang creator upang magsimulang bumuo ng tuloy-tuloy na watch list.",
    "ht": "Tape bouton \"Lineup\" a sou nenpòt video kreator pou ou komanse bati yon lis kontinyèl gade.",
    "ja": "クリエイターの動画にある「ラインアップ」ボタンをタップして、連続再生リストの作成を開始します。",
    "nl": "Tik op de \"Afspeellijst\" knop op een video van een maker om een doorlopende kijklijst samen te stellen.",
    "pl": "Dotknij przycisk \"Lineup\" na filmie dowolnego twórcy, aby rozpocząć tworzenie ciągłej listy oglądania.",
    "tr": "Herhangi bir içerik yaratıcısının videosundaki \"Oynatma Sırası\" düğmesine dokunarak sürekli bir izleme listesi oluşturmaya başlayın."
  },
  "Tap the bookmark icon next to any verse to save it here.": {
    "es": "Toca el icono de marcador junto a cualquier versículo para guardarlo aquí.",
    "fr": "Appuyez sur l'icône de signet à côté de n'importe quel verset pour l'enregistrer ici.",
    "pt": "Toque no ícone de favorito ao lado de qualquer versículo para salvá-lo aqui.",
    "de": "Tippe auf das Lesezeichensymbol neben einem beliebigen Vers, um ihn hier zu speichern.",
    "it": "Tocca l'icona del segnalibro accanto a qualsiasi versetto per salvarlo qui.",
    "ru": "Нажмите на значок закладки рядом с любым стихом, чтобы сохранить его здесь.",
    "hi": "इसे यहाँ सेव करने के लिए किसी भी कविता के बगल में मौजूद बुकमार्क आइकन पर टैप करें।",
    "ar": "اضغط على أيقونة الحفظ بجانب أي آية لحفظها هنا.",
    "zh-CN": "点击任何经文旁的书签图标，将其保存到此处。",
    "sw": "Gusa ikoni ya alamisho karibu na ayat yoyote ili kuihifadhi hapa.",
    "ko": "모든 구절 옆의 북마크 아이콘을 탭하여 여기에 저장하세요.",
    "vi": "Nhấn vào biểu tượng dấu trang bên cạnh bất kỳ đoạn Kinh Thánh nào để lưu nó tại đây.",
    "tl": "I-tap ang bookmark icon sa tabi ng anumang verse upang i-save ito dito.",
    "ht": "Tape sou icon marke a ki bòkòt nenpòt vèse pou sove li isit.",
    "ja": "任意の節の隣にあるブックマークアイコンをタップして、ここに保存してください。",
    "nl": "Tik op het bladwijzerpictogram naast een vers om het hier op te slaan.",
    "pl": "Naciśnij ikonę zakładki obok dowolnego wersetu, aby zapisać go tutaj.",
    "tr": "Herhangi bir ayetin yanındaki yer imi simgesine dokunarak buraya kaydedin."
  },
  "Text coming soon": {
    "es": "pronto ...",
    "fr": "Bientôt disponible",
    "pt": "Em breve",
    "de": "Text in Kürze.",
    "ru": "Текст будет скоро!",
    "hi": "जल्द ही आ रही हैं",
    "zh-CN": "我准备好了。请提供需要翻译的英文文本。",
    "sw": "Asilia",
    "ko": "저를 기다리고 있어 주셔서 감사합니다. 번역할 텍스트가 준비되면 자연스럽고 현대적인 한국어로 번역해드리겠습니다.",
    "vi": "Tôi đang chờ. Vui lòng gửi văn bản cần dịch.",
    "tl": "Naghihintay para sa iyong teksto. Handa akong magsalin kapag ikaw ay nagsumite na.",
    "ht": "M ap tann pou tèks la.",
    "ja": "了解しました。テキストをお待ちしています。翻訳の準備ができています。",
    "pl": "Czekam na tekst do przetłumaczenia.",
    "tr": "Anladım. Çevirisini yapmaya hazırım. Lütfen metni gönderin."
  },
  "The Apocrypha": {
    "es": "Los Libros Apócrifos",
    "fr": "Les apocryphes",
    "pt": "Os Apócrifos",
    "de": "Sind die Apokryphen kanonisch?",
    "it": "L'Apocrifi",
    "ru": "Апокрифы",
    "hi": "द एपोक्रिफा",
    "ar": "الكتب الإضافية",
    "zh-CN": "伪经",
    "sw": "Vitabu vya Ziada",
    "ko": "외경",
    "vi": "Những Sách Được Coi Là Không Chính Thức",
    "tl": "Ang Apokripa",
    "ht": "Apokrifal yo",
    "ja": "外典",
    "nl": "De Apocriefen",
    "pl": "Apokryfa",
    "tr": "Apokrıf"
  },
  "The Hidden Books": {
    "es": "Los Libros Ocultos",
    "fr": "Les livres cachés",
    "pt": "Os Livros Escondidos",
    "de": "Die verborgenen Bücher",
    "it": "I Libri Nascosti",
    "ru": "Скрытые книги",
    "hi": "द हिडन बुक्स",
    "ar": "الكتب المخفية",
    "zh-CN": "隐藏的书卷",
    "sw": "Vitabu Vya Siri",
    "ko": "숨겨진 책",
    "vi": "Những Cuốn Sách Ẩn Giấu",
    "tl": "Ang Mga Nakatagong Libro",
    "ht": "Liv yo ki Kache yo",
    "ja": "隠された書物",
    "nl": "De Verborgen Boeken",
    "pl": "Ukryte Księgi",
    "tr": "Gizli Kitaplar"
  },
  "The animated Bible stories are free for everyone. Become a supporter to unlock the full family movie library.": {
    "es": "Las historias animadas de la Biblia son gratuitas para todos. Conviértete en un simpatizante para desbloquear la biblioteca completa de películas familiares.",
    "fr": "Les histoires bibliques animées sont gratuites pour tous. Devenez un partisan pour débloquer la bibliothèque complète de films familiaux.",
    "pt": "As histórias bíblicas animadas são gratuitas para todos. Torne-se um apoiador para desbloquear a biblioteca completa de filmes da família.",
    "de": "Die animierten Bibelgeschichten sind für alle kostenlos. Werde ein Unterstützer, um die gesamte Familienfilmbibliothek freizuschalten.",
    "it": "Le storie bibliche animate sono gratuite per tutti. Diventa un sostenitore per sbloccare l'intera videoteca di film per famiglie.",
    "ru": "Анимированные библейские истории бесплатны для всех. Станьте сторонником, чтобы разблокировать полную семейную библиотеку фильмов.",
    "hi": "एनिमेटेड बाइबल कहानियाँ सभी के लिए मुफ़्त हैं। पूरे परिवार की मूवी लाइब्रेरी को अनलॉक करने के लिए एक समर्थक बनें।",
    "ar": "قصص الكتاب المقدس المتحركة متاحة مجاناً للجميع. كن مؤيداً لنا لفتح مكتبة الأفلام العائلية الكاملة.",
    "zh-CN": "这些动画圣经故事对所有人免费提供。成为支持者解锁完整的家庭电影库。",
    "sw": "Hadithi za Biblia zilizohuishwa ni bure kwa kila mtu. Kuwa msaidizi wa kufungua maktaba kamili ya sinema ya familia.",
    "ko": "애니메이션 성경 이야기는 모두에게 무료입니다. 후원자가 되어 전체 가족 영화 라이브러리를 잠금 해제하세요.",
    "vi": "Những câu chuyện Kinh Thánh được hoạt hình là miễn phí cho tất cả mọi người. Trở thành người ủng hộ để mở khóa thư viện phim gia đình đầy đủ.",
    "tl": "Ang mga animated na kwento mula sa Biblia ay libre para sa lahat. Maging sumusuporta upang mabukas ang buong library ng pelikula pang-pamilya.",
    "ht": "Istwa Bib la ki animate yo gratis pou tout moun. Vin yon sipòte pou debloke bibliyotèk fim fanmi konplè a.",
    "ja": "アニメーション化した聖書のお話は、みんなのために無料です。サポーターになって、完全なファミリー映画ライブラリーを開放しましょう。",
    "nl": "De geanimeerde bijbelverhalen zijn gratis voor iedereen. Word een supporter om de volledige bibliotheek met familiefilms te ontgrendelen.",
    "pl": "Animowane biblijne historie są dostępne bezpłatnie dla wszystkich. Zostań wspierającym, aby odblokować pełną bibliotekę filmów familijnych.",
    "tr": "Canlandırılmış İncil hikayeleri herkese açıktır. Tam aile filmi kütüphanesinin kilidini açmak için bir destekçi olun."
  },
  "This will permanently remove all your data. Type \"DELETE\" to confirm.": {
    "es": "Esto eliminará de forma permanente todos tus datos. Escriba \"ELIMINAR\" para confirmar.",
    "fr": "Cela supprimera définitivement toutes vos données. Tapez « SUPPRIMER » pour confirmer.",
    "pt": "Isso removerá permanentemente todos os seus dados. Digite \"EXCLUIR\" para confirmar.",
    "de": "Dadurch werden alle Ihre Daten dauerhaft entfernt. Geben Sie \"LÖSCHEN\" ein, um zu bestätigen.",
    "it": "Questo eliminerà permanentemente tutti i tuoi dati. Digita \"DELETE\" per confermare.",
    "ru": "Это приведет к окончательному удалению всех ваших данных. Введите «УДАЛИТЬ» для подтверждения.",
    "hi": "यह आपके सभी डेटा को स्थायी रूप से हटा देगा। कन्फ़र्म करने के लिए \"मिटाएँ\" टाइप करें।",
    "ar": "سيؤدي هذا إلى حذف جميع بيانات التي لديك بشكل دائم. اكتب \"DELETE\" للتأكيد.",
    "zh-CN": "这将永久删除您的所有数据。输入\"删除\"以确认。",
    "sw": "Hii itaondoa kabisa data yako yote. Andika \"DELETE\" ili kuthibitisha.",
    "ko": "이것은 모든 데이터를 영구적으로 삭제합니다. 확인하려면 \"DELETE\"를 입력하세요.",
    "vi": "Điều này sẽ xóa vĩnh viễn tất cả dữ liệu của bạn. Hãy gõ \"DELETE\" để xác nhận.",
    "tl": "Ito ay permanent na tanggalin ang lahat ng iyong data. I-type ang \"DELETE\" upang kumpirmahin.",
    "ht": "Sa a pral retire tout done ou yo pou tout tan. Tape \"DELETE\" pou konfime.",
    "nl": "Dit zal al je gegevens permanent verwijderen. Type \"VERWIJDEREN\" om te bevestigen.",
    "pl": "To potwali usunąć wszystkie Twoje dane na stałe. Wpisz \"DELETE\" aby potwierdzić.",
    "tr": "Bu, tüm verilerinizi kalıcı olarak silecektir. Onaylamak için \"DELETE\" yazınız."
  },
  "Today's faith headlines from our Live Newsroom.": {
    "es": "Titulares de fe de hoy de nuestra Sala de Prensa en Vivo.",
    "fr": "Les gros titres de la foi d'aujourd' hui dans notre salle de presse en direct.",
    "pt": "As manchetes religiosas de hoje da nossa Sala de Imprensa ao Vivo.",
    "de": "Heutige Glaubens-Schlagzeilen aus unserem Live-Newsroom.",
    "it": "I titoli di fede di oggi dalla nostra Sala Stampa in Diretta.",
    "ru": "Сегодняшние новости о вере из нашего отдела новостей в прямом эфире.",
    "hi": "हमारे लाइव न्यूज़रूम से आज की आस्था की सुर्खियां।",
    "ar": "عناوين الإيمان لليوم من غرفة الأخبار المباشرة لدينا.",
    "zh-CN": "今天来自我们实时新闻编辑室的信仰新闻头条。",
    "sw": "Vichwa vya habari vya imani ya leo kutoka kwenye Chumba chetu cha Habari cha Moja kwa Moja.",
    "ko": "생방송 뉴스룸의 오늘의 신앙 헤드라인.",
    "vi": "Các tiêu đề tin tức về Đức tin hôm nay từ Phòng Tin tức Trực tiếp của chúng tôi.",
    "tl": "Ang mga pangunahing balita tungkol sa fe para ngayong araw mula sa aming Live Newsroom.",
    "ht": "Nouvèl sou Lafwa jodi a soti nan Chanm Nouvèl Dirèk nou yo.",
    "ja": "今日の信仰ニュースヘッドラインをライブニュースルームからお届けします。",
    "nl": "De geloofskoppelingen van vandaag uit onze live nieuwsredactie.",
    "pl": "Dzisiejsze wiadomości z naszej Redakcji na żywo dotyczące wiary.",
    "tr": "Bugünün inanç başlıkları Canlı Haber Merkezimizden."
  },
  "Today's reading": {
    "es": "Lectura desde el presente",
    "fr": "Lecture d'aujourd' hui",
    "pt": "Leitura de hoje",
    "de": "Heutige Lesung",
    "it": "La lettura di oggi",
    "ru": "Сегодняшнее чтение",
    "hi": "आज का पढ़ना",
    "ar": "قراءة اليوم",
    "sw": "Kusoma kwa Leo",
    "ko": "오늘의 독서",
    "tl": "Ang binasa ngayong araw",
    "ht": "Lekti jou a",
    "ja": "今日の朗読",
    "pl": "Dzisiejsze czytanie"
  },
  "Today's streak": {
    "es": "Racha de hoy",
    "fr": "La série d'aujourd' hui",
    "pt": "Sequência de hoje",
    "de": "Heutige Serie",
    "it": "La serie di oggi",
    "ru": "Сегодняшняя серия",
    "hi": "आज की लकीर",
    "ar": "اليوم الممتد (أو سلسلتك اليوم)",
    "zh-CN": "今天的连胜纪录",
    "sw": "Mkakati wa leo",
    "ko": "오늘의 연속",
    "vi": "Chuỗi ngày hôm nay",
    "tl": "Ang streak mo ngayon",
    "ht": "Estrik jodi a",
    "ja": "今日のストリーク",
    "nl": "Vandaag's reeks",
    "pl": "Dzisiejsza seria",
    "tr": "Bugünün serisi"
  },
  "Trusted pastors and teachers from across the Body of Christ.": {
    "es": "Pastores y maestros de confianza de todo el Cuerpo de Cristo.",
    "fr": "Pasteurs et enseignants de confiance de tout le Corps du Christ.",
    "pt": "Pastores e professores de confiança de todo o Corpo de Cristo.",
    "de": "Vertrauenswürdige Pastoren und Lehrer aus dem ganzen Leib Christi.",
    "it": "Pastori e insegnanti fidati da tutto il Corpo di Cristo.",
    "ru": "Доверенные пасторы и учителя со всего Тела Христова.",
    "hi": "मसीह की देह के पार से भरोसेमंद पादरी और शिक्षक।",
    "ar": "الرعاة والمعلمون الموثوقون من جميع أنحاء جسد المسيح.",
    "zh-CN": "来自基督身体各地受信任的牧师和教师。",
    "sw": "Viongozi na walimu wenye ujumbe kutoka kote katika Mwili wa Kristo.",
    "ko": "그리스도의 몸 전체에서 신뢰받는 목회자와 교사.",
    "vi": "Những vị mục sư và giáo sư đáng tin cậy từ khắp Cơ Thể của Đấng Christ.",
    "tl": "Mga pinagkakatiwalaang pastor at guro mula sa buong Katawan ng Kristo.",
    "ht": "Pastè ak pwofesè yo ki dwe fye sou yo soti nan tout Kò Kris la.",
    "ja": "キリストの体全体から来た信頼できる牧師たちと教師たち。",
    "nl": "Vertrouwde predikanten en leraren van over het hele Lichaam van Christus.",
    "pl": "Zaufani pastorowie i nauczyciele z całego Ciała Chrystusa.",
    "tr": "Mesih'in Bedeninden güvenilir öğretmenler ve pastorlar."
  },
  "Try these": {
    "es": "Prueba estos.",
    "fr": "Voyons ce que vous dites de ceux-ci.",
    "pt": "Tente essas:",
    "de": "Versuchen Sie es mit diesen Schritten.",
    "ru": "Примерьте эти",
    "hi": "इन्हें आज़माएँ",
    "ar": "أنا مستعد لترجمة النصوص من الإنجليزية إلى العربية الحديثة الطبيعية. يرجى تقديم النصوص التي تريد ترجمتها.",
    "sw": "Jaribu haya",
    "ko": "다음 방법을 시도해보세요",
    "ht": "Mwen pret! Vini, bay mwen tèks la pou tradiyi nan Kreyòl Ayisyen.",
    "ja": "申し訳ありませんが、翻訳するテキストが記載されていません。翻訳したい英語のテキストをお知らせください。",
    "pl": "Spróbuj tego",
    "tr": "I don't see any text to translate. Could you please provide the English text you'd like me to translate into Turkish?"
  },
  "Type at least 2 letters to start searching.": {
    "es": "Escribe al menos 2 letras para comenzar a buscar.",
    "fr": "Tapez au moins 2 lettres pour commencer la recherche.",
    "pt": "Digite pelo menos 2 letras para começar a pesquisar.",
    "de": "Geben Sie mindestens 2 Buchstaben ein, um mit der Suche zu beginnen.",
    "it": "Digita almeno 2 lettere per iniziare la ricerca.",
    "ru": "Введите не менее 2 букв, чтобы начать поиск.",
    "hi": "खोज शुरू करने के लिए कम - से - कम 2 अक्षर टाइप करें।",
    "ar": "أدخل حرفين على الأقل لبدء البحث.",
    "zh-CN": "至少输入2个字母才能开始搜索。",
    "sw": "Andika angalau herufi 2 ili kuanza kutafuta.",
    "ko": "검색을 시작하려면 최소 2글자 이상을 입력하세요.",
    "vi": "Hãy nhập ít nhất 2 ký tự để bắt đầu tìm kiếm.",
    "tl": "Kailangan ng hindi bababa sa 2 na letrang i-type upang magsimulang mag-hanaap.",
    "ht": "Tape omwen 2 lèt pou komanse rechèch.",
    "ja": "検索を開始するには、少なくとも2文字入力してください。",
    "nl": "Typ minstens 2 letters om te beginnen met zoeken.",
    "pl": "Wpisz co najmniej 2 litery, aby rozpocząć wyszukiwanie.",
    "tr": "En az 2 harf yazın aramaya başlamak için."
  },
  "Unfriend": {
    "es": "Eliminar amistad",
    "fr": "Retirer contact",
    "pt": "Desfazer amizade",
    "de": "Entfreunden",
    "it": "Rimuovere dai contatti",
    "ru": "УБРАТЬ ИЗ ДРУЗЕЙ",
    "hi": "अनफ्रेंड",
    "ar": "إلغاء الصداقة",
    "zh-CN": "取消好友关系",
    "sw": "Kutofautiana/Kuacha kuwa rafiki",
    "ko": "친구취소",
    "vi": "Hủy kết bạn",
    "tl": "Alisin mula sa kaibigan",
    "ht": "Retire koneksyon",
    "ja": "友だちをやめる",
    "nl": "Uit vriendschap zetten",
    "pl": "Usunąć ze znajomych",
    "tr": "Arkadaşlıktan çıkarmak"
  },
  "Unlimited AI Storybooks for kids": {
    "es": "Libros de cuentos ilimitados de IA para niños",
    "fr": "Livres d'histoires d'IA illimités pour les enfants",
    "pt": "Livros de histórias de IA ilimitados para crianças",
    "de": "Unbegrenzte KI-Storybooks für Kinder",
    "it": "Storie AI Illimitate per Bambini",
    "ru": "Неограниченное количество книг по искусственному интеллекту для детей",
    "hi": "बच्चों के लिए असीमित AI स्टोरीबुक",
    "ar": "كتب قصص غير محدودة بالذكاء الاصطناعي للأطفال",
    "zh-CN": "儿童无限AI故事书",
    "sw": "Vitabu vya hadithi vya AI bila kikomo kwa watoto",
    "ko": "어린이를 위한 무제한 AI 스토리북",
    "vi": "Sách Truyện AI Không Giới Hạn Cho Trẻ Em",
    "tl": "Walang hanggang AI Kuwento para sa mga bata",
    "ht": "Liv san limit AI pou timoun yo",
    "ja": "子どもたちのための無制限のAIストーリーブック",
    "nl": "Onbeperkte AI-verhalenboeken voor kinderen",
    "pl": "Nieograniczone książki opowieści ze sztuczną inteligencją dla dzieci",
    "tr": "Çocuklar için Sınırsız AI Hikaye Kitapları"
  },
  "Unlock all family films": {
    "es": "Desbloquear todas las películas familiares",
    "fr": "Débloquez tous les films de famille",
    "pt": "Desbloqueie todos os filmes para a família",
    "de": "Alle Familienfilme freischalten",
    "it": "Sblocca tutti i film per famiglie",
    "ru": "Разблокируйте все семейные фильмы",
    "hi": "सभी पारिवारिक फिल्मों को अनलॉक करें",
    "ar": "فتح جميع أفلام العائلة",
    "zh-CN": "解锁所有家庭电影",
    "sw": "Fungua filamu zote za familia",
    "ko": "모든 가족 영화의 잠금을 해제하세요",
    "vi": "Mở khóa tất cả các bộ phim gia đình",
    "tl": "Buksan ang lahat ng pelikula para sa pamilya",
    "ht": "Debloke tout fim fanmi yo",
    "ja": "すべてのファミリー映画のロックを解除する",
    "nl": "Ontgrendel alle familiefilms",
    "pl": "Odblokuj wszystkie filmy familijne",
    "tr": "Tüm aile filmlerinin kilidini aç"
  },
  "View all 613 precepts": {
    "es": "Ver los 613 preceptos",
    "fr": "Voir les 613 préceptes",
    "pt": "Ver todos os 613 preceitos",
    "de": "Alle 613 Gebote anzeigen",
    "it": "Visualizza tutti i 613 precetti",
    "ru": "Посмотреть все 613 заповедей",
    "hi": "सभी 613 उपदेश देखें",
    "ar": "عرض جميع الوصايا الـ 613",
    "zh-CN": "查看全部613条诫命",
    "sw": "Angalia maagizo yote 613",
    "ko": "613개 법규 모두 보기",
    "vi": "Xem tất cả 613 điều luật",
    "tl": "Tingnan ang lahat ng 613 na mga utos",
    "ht": "Gade tout 613 presepta yo",
    "ja": "613の戒律をすべて表示",
    "nl": "Bekijk alle 613 geboden",
    "pl": "Wyświetl wszystkie 613 przykazań",
    "tr": "613 mitzvayı görüntüle"
  },
  "Watch Stories": {
    "es": "Ver historias",
    "fr": "Regarder des histoires",
    "pt": "Ver histórias",
    "de": "Geschichten ansehen",
    "it": "Guarda Storie",
    "ru": "Смотреть истории",
    "hi": "कहानियाँ देखें",
    "ar": "شاهد القصص",
    "zh-CN": "观看故事",
    "sw": "Angalia Hadithi",
    "ko": "시청 이야기",
    "vi": "Xem Các Câu Chuyện",
    "tl": "Manood ng mga Kuwento",
    "ht": "Gade Istwa",
    "ja": "ウォッチストーリーズ",
    "nl": "Bekijk Verhalen",
    "pl": "Obejrzyj Opowieści",
    "tr": "Hikaye İzle"
  },
  "Watch later": {
    "es": "Ver después",
    "fr": "Regarder plus tard",
    "pt": "Ver Depois",
    "de": "Später ansehen",
    "it": "Guarda più tardi",
    "ru": "Посмотреть позже",
    "hi": "मैं आपको बाद में दिखाऊंगा",
    "ar": "شاهد لاحقاً",
    "zh-CN": "稍后观看",
    "sw": "Tazama baadaye",
    "ko": "나중에 보기",
    "vi": "Xem sau",
    "tl": "Panoorin mamaya",
    "ht": "Gade pita",
    "ja": "後で見る",
    "nl": "Bekijk later",
    "pl": "Obejrzyj później",
    "tr": "Daha sonra izle"
  },
  "Whole Bible · 1611 KJV": {
    "es": "Biblia Completa · 1611 KJV",
    "fr": "Bible entière · 1611 KJV",
    "pt": "Bíblia Inteira · 1611 KJV",
    "de": "Die ganze Bibel · 1611 KJV",
    "it": "Intera Bibbia · 1611 KJV",
    "ru": "Вся Библия · 1611 KJV",
    "hi": "संपूर्ण बाइबल · 1611 KJV",
    "ar": "الكتاب المقدس الكامل · 1611 KJV",
    "zh-CN": "整本圣经·1611年国王詹姆斯版",
    "sw": "Biblia Nzima · 1611 KJV",
    "ko": "성경 전체 · 1611 KJV",
    "vi": "Toàn Bộ Thánh Kinh · 1611 KJV",
    "tl": "Buong Biblia · 1611 KJV",
    "ht": "Bib Konplè · 1611 KJV",
    "ja": "聖書全巻・1611年版欽定訳聖書",
    "nl": "Hele Bijbel · 1611 KJV",
    "pl": "Cała Biblia · 1611 KJV",
    "tr": "Tüm İncil · 1611 KJV"
  },
  "Your circle": {
    "es": "Tu círculo",
    "fr": "Votre cercle",
    "pt": "O seu círculo",
    "de": "Ihr Kreis",
    "it": "Il tuo cerchio",
    "ru": "Ваш круг",
    "hi": "आपकी मंडली",
    "ar": "دائرتك",
    "zh-CN": "你的圈子",
    "sw": "Mzunguko wako",
    "ko": "당신의 원",
    "vi": "Vòng tròn của bạn",
    "tl": "Ang iyong bilog",
    "ht": "Sèk ou a",
    "ja": "あなたの輪",
    "nl": "Jouw cirkel",
    "pl": "Twój krąg",
    "tr": "Senin çevren"
  },
  "Your collection": {
    "es": "Su colección:",
    "fr": "Votre collection",
    "pt": "Sua Coleção",
    "de": "Deine Sammlung",
    "it": "La tua collezione",
    "ru": "ÐÐ¾Ð»Ð»ÐµÐºÑÐ¸Ð¸ Ð°Ð»ÑÐ±Ð¾Ð¼Ð¾Ð² Ð´Ð¾Ð»Ð¶Ð½Ð° ÑÐ¾Ð´ÐµÑÐ¶Ð°ÑÑ",
    "hi": "एलबम संग्रह",
    "ar": "مجموعتك",
    "zh-CN": "你的收藏",
    "sw": "Mkusanyo wako",
    "ko": "탱크 콜렉션&#x0D;",
    "vi": "Bộ sưu tập của bạn",
    "tl": "Ang iyong koleksyon",
    "ht": "Koleksyon ou",
    "ja": "あなたのコレクション",
    "nl": "Uw verzameling",
    "pl": "Twoja kolekcja",
    "tr": "Sizin koleksiyonunuz"
  },
  "Your lineup is empty": {
    "es": "Tu alineación está vacía",
    "fr": "Votre gamme est vide",
    "pt": "O seu alinhamento está vazio",
    "de": "Ihre Aufstellung ist leer",
    "it": "La tua formazione è vuota",
    "ru": "Ваш состав пуст",
    "hi": "आपका लाइनअप खाली है",
    "ar": "صفك فارغ",
    "zh-CN": "你的阵容是空的",
    "sw": "Orodha yako ni tupu",
    "ko": "라인업이 비어 있습니다",
    "vi": "Danh sách của bạn trống rỗng",
    "tl": "Ang iyong lineup ay walang laman",
    "ht": "Liy ou a vid",
    "ja": "あなたのラインアップは空です",
    "nl": "Je opstelling is leeg",
    "pl": "Twoja lista jest pusta",
    "tr": "Senin sıran boş"
  },
  "Your watch lineup": {
    "es": "Tu línea de relojes",
    "fr": "Votre gamme de montres",
    "pt": "A sua linha de relógios",
    "de": "Ihr Uhren-Lineup",
    "it": "La tua collezione di orologi",
    "ru": "Ваша линейка часов",
    "hi": "आपका वॉच लाइनअप",
    "ar": "تشكيلة ساعتك",
    "zh-CN": "你的手表系列",
    "sw": "Mstari wa saa zako",
    "ko": "워치 라인업",
    "vi": "Dòng đồng hồ của bạn",
    "tl": "Ang iyong koleksyon ng relo",
    "ht": "Dyòl montè ou yo",
    "ja": "あなたの時計のラインアップ",
    "nl": "Je klokcollectie",
    "pl": "Twoja kolekcja zegarków",
    "tr": "Saat koleksiyonunuz"
  },
  "best": {
    "es": "mejor",
    "fr": "meilleur",
    "pt": "nhor",
    "de": "beste",
    "it": "migliore",
    "ru": "лучший",
    "hi": "सर्वोत्तम",
    "ar": "الأفضل",
    "zh-CN": "最好的",
    "sw": "bora zaidi",
    "ko": "제일",
    "vi": "tốt nhất",
    "tl": "pinakamahusay",
    "ht": "Mèyè",
    "ja": "最高",
    "pl": "najlepszy",
    "tr": "en iyi"
  },
  "entries": {
    "es": "entradas",
    "fr": "entrées",
    "pt": "lançamentos",
    "de": "Einträge",
    "it": "voci",
    "ru": "записи",
    "hi": "प्रविष्टियाँ",
    "ar": "الإدخالات",
    "zh-CN": "条目",
    "sw": "viingizo",
    "ko": "항목들",
    "vi": "mục nhập",
    "tl": "mga entry\nmga isinasaad\nmga katala\nmga record",
    "ht": "Antire",
    "ja": "エントリー",
    "nl": "vermeldingen",
    "pl": "wpisy",
    "tr": "girdiler"
  },
  "every day this month we surface a different chapter of the story.": {
    "es": "cada día de este mes sacamos a la superficie un capítulo diferente de la historia.",
    "fr": "chaque jour ce mois-ci, nous faisons ressortir un chapitre différent de l'histoire.",
    "pt": "todos os dias deste mês, revelamos um capítulo diferente da história.",
    "de": "jeden Tag in diesem Monat tauchen wir in ein anderes Kapitel der Geschichte ein.",
    "it": "ogni giorno di questo mese portiamo alla luce un capitolo diverso della storia.",
    "ru": "каждый день в этом месяце мы открываем новую главу истории.",
    "hi": "इस महीने हर दिन हम कहानी के एक अलग अध्याय को सामने लाते हैं।",
    "ar": "كل يوم في هذا الشهر نكشف عن فصل مختلف من القصة.",
    "zh-CN": "这个月我们每天都展现故事的不同篇章。",
    "sw": "kila siku katika miezi hii tunatoa sura tofauti ya hadithi.",
    "ko": "이번 달에는 매일 우리는 이야기의 다른 장을 보여줍니다.",
    "vi": "Hàng ngày trong tháng này chúng ta đưa ra một chương khác nhau của câu chuyện.",
    "tl": "bawat araw ngayong buwan, aabutin natin ang ibang kabanata ng kuwento.",
    "ht": "Chak jou nan mwa sa a nou wete yon chapit diferan nan istwa a.",
    "ja": "今月は毎日、物語の別の章を浮かび上がらせます。",
    "nl": "elke dag deze maand brengen we een ander hoofdstuk van het verhaal aan het licht.",
    "pl": "Każdego dnia tego miesiąca wydobywamy inny rozdział opowieści.",
    "tr": "Bu ayın her günü hikayenin farklı bir bölümünü ortaya çıkarıyoruz."
  },
  "precepts": {
    "es": "preceptos",
    "fr": " Les préceptes :",
    "pt": "Preceitos.",
    "de": "gebote",
    "it": "precetti",
    "ru": "УКАЗАНИЯ",
    "hi": "उपदेश",
    "ar": "أصول التعاليم",
    "zh-CN": "训诫",
    "sw": "Maelezo",
    "ko": "계명",
    "vi": "những lời dạy",
    "tl": "mga prinsipyo",
    "ht": "Presepta",
    "ja": "教え",
    "nl": "voorschriften",
    "pl": "zasady",
    "tr": "ilkeler"
  },
  "sermons from the great Black American pulpit — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor, and many more.": {
    "es": "sermones desde el gran púlpito afroamericano: Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, el obispo Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor y muchos más.",
    "fr": "sermons de la grande chaire noire américaine — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, l'évêque Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor, et bien d'autres.",
    "pt": "sermões do grande púlpito negro americano — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bispo Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor e muitos mais.",
    "de": "predigten von der großen schwarzen amerikanischen Kanzel — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bischof Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor und viele mehr.",
    "it": "Sermoni dal grande pulpito afroamericano — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor, e molti altri.",
    "ru": "проповеди с великой кафедры чернокожих американцев — Стивена Дарби, Т. Д. Джейкса, Тони Эванса, Сары Джейкс Робертс, епископа Ноэля Джонса, Отиса Мосса III, Вашти Маккензи, Гарднера К. Тейлора и многих других.",
    "hi": "महान अश्वेत अमेरिकी लुगदी से उपदेश — स्टीफन डार्बी, टीडी जेक, टोनी इवांस, सारा जेक रॉबर्ट्स, बिशप नोएल जोन्स, ओटिस मॉस III, वश्ती मैकेंजी, गार्डनर सी टेलर, और कई अन्य।",
    "ar": "الخطب من المنبر الأسود الأمريكي العظيم — Stephen Darby و T.D. Jakes و Tony Evans و Sarah Jakes Roberts و Bishop Noel Jones و Otis Moss III و Vashti McKenzie و Gardner C. Taylor وكثيرين آخرين.",
    "zh-CN": "来自美国伟大黑人讲坛的布道——Stephen Darby、T.D. Jakes、Tony Evans、Sarah Jakes Roberts、Bishop Noel Jones、Otis Moss III、Vashti McKenzie、Gardner C. Taylor等众多人士。",
    "sw": "Manyazo kutoka kwa kiti mikubwa cha Waamerika weusi — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor, na wengi zaidi.",
    "ko": "stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor 등 위대한 흑인 강단의 설교.",
    "vi": "những bài giảng từ những vị giảng viên người Mỹ da đen vĩ đại — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor, và nhiều người khác.",
    "tl": "mga sermon mula sa mahusay na Black American na pulpito — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor, at marami pang iba.",
    "ht": "Serimòn soti nan gwo chaple Ameriken Nwa — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor, ak anpil lòt ankò.",
    "ja": "偉大なアフリカ系アメリカ人の説教壇からの説教——Stephen Darby、T.D. Jakes、Tony Evans、Sarah Jakes Roberts、Bishop Noel Jones、Otis Moss III、Vashti McKenzie、Gardner C. Taylor、その他多くの説教者たち。",
    "nl": "preken van de grote zwarte Amerikaanse kansel — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor, en veel meer.",
    "pl": "Kazania z wielkiej czarnoamerykańskiej ambony — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor i wielu innych.",
    "tr": "Büyük Siyah Amerikan vaazından vaazlar — Stephen Darby, T.D. Jakes, Tony Evans, Sarah Jakes Roberts, Bishop Noel Jones, Otis Moss III, Vashti McKenzie, Gardner C. Taylor ve daha birçok kişi."
  },
  "translating all 917 precepts": {
    "es": "traduciendo los 917 preceptos",
    "fr": "traduction des 917 préceptes",
    "pt": "traduzindo todos os 917 preceitos",
    "de": "übersetzung aller 917 Gebote",
    "it": "traducendo tutti i 917 precetti",
    "ru": "перевод всех 917 заповедей",
    "hi": "सभी 917 उपदेशों का अनुवाद करना",
    "ar": "ترجمة جميع الـ 917 وصايا",
    "zh-CN": "翻译全部917条诫命",
    "sw": "Kutafsiri amri zote za 917",
    "ko": "917개의 모든 계명 번역",
    "vi": "dịch tất cả 917 điều răn",
    "tl": "Isinasalin ang lahat ng 917 mga paalala",
    "ht": "Tradui tout 917 presepta yo",
    "ja": "917の戒めすべてを翻訳すること",
    "nl": "alle 917 geboden vertalen",
    "pl": "tłumaczenie wszystkich 917 przykazań",
    "tr": "917 öğütün tamamını çevirmek"
  },
  "References": {
    "fr": "Références",
    "pt": "Referências",
    "de": "Literatur",
    "it": "Riferimenti",
    "ru": "Список использованной литературы",
    "hi": "संदर्भ",
    "ar": "المراجع",
    "zh-CN": "参考文献",
    "sw": "Marejeleo",
    "ko": "참고 사항",
    "vi": "Tài liệu tham khảo",
    "tl": "Mga Sanggunian",
    "ht": "Referans",
    "nl": "Verwijzingen",
    "pl": "Odnośniki",
    "tr": "Referanslar"
  },
  "Videos": {
    "fr": "Vidéos",
    "pt": "Vídeos",
    "de": "videos",
    "it": "Video",
    "ru": "Видео",
    "hi": "वीडियो",
    "ar": "مقاطع الفيديو",
    "zh-CN": "视频",
    "sw": "Video",
    "ko": "비디오",
    "vi": "Video",
    "tl": "Mga Video",
    "ht": "Videyo",
    "ja": "ビデオ",
    "nl": "Video's",
    "pl": "Filmy",
    "tr": "Videolar"
  },
  "ch": {
    "fr": ".",
    "ru": "ч",
    "hi": "chidiya akash me udti hai chidiya Aakash mein bolati hai",
    "zh-CN": "我准备好了。请提供您要翻译的英文文本。",
    "ko": "제가 도와드릴 수 있는 것이 무엇인지 확실하지 않습니다. 번역하실 영문 텍스트를 제공해 주시겠어요?",
    "vi": "I need more text to translate. Please provide the English text you'd like me to translate into Vietnamese."
  },
  "translating": {
    "fr": "traduction en cours",
    "pt": "Processo de Tradução",
    "de": "Übersetzungen",
    "ru": "переводится... ",
    "hi": "अनुवाद किया जा रहा है",
    "ar": "أنا مستعد للترجمة. يرجى تقديم النص الذي تريد ترجمته من الإنجليزية إلى العربية.",
    "zh-CN": "我准备好了翻译。请提供您想要翻译成简体中文的英文文本。",
    "sw": "kutafsiri",
    "ko": "번역 중",
    "tl": "Handa akong magpagsalin. Ipadala mo na ang teksto na gustong mong isalin mula sa Ingles tungo sa Tagalog.",
    "pl": "Czekam na tekst do tłumaczenia. Proszę podać tekst angielski, który chciałbyś przełożyć na polski."
  }
};
